(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWzebra_atlas_", frames: [[628,514,208,208],[634,724,176,176],[596,1756,64,200],[916,1552,64,200],[346,1588,76,184],[594,1232,114,142],[662,1756,64,192],[260,1572,84,170],[0,1722,100,190],[932,1374,88,176],[254,1444,116,126],[502,1232,90,210],[714,1124,90,210],[938,962,82,204],[710,1336,76,202],[474,1444,74,196],[594,1376,114,142],[932,1168,76,204],[390,1406,82,180],[138,1390,114,182],[130,1574,128,128],[806,1276,124,150],[806,1124,124,150],[0,1570,128,150],[0,1418,128,150],[140,1230,136,158],[0,1258,136,158],[796,962,140,160],[572,1070,140,160],[0,1088,138,168],[158,1060,138,168],[102,1874,126,150],[102,1722,126,150],[410,1164,90,240],[298,1202,90,240],[300,948,108,252],[156,528,154,286],[0,528,154,286],[476,724,156,270],[0,816,156,270],[838,514,162,262],[312,684,162,262],[158,816,140,242],[410,996,160,166],[634,902,160,166],[812,778,148,182],[352,1892,120,116],[550,1520,120,116],[788,1428,120,116],[672,1546,120,116],[794,1546,120,116],[230,1774,120,116],[474,1760,120,116],[230,1892,120,116],[550,1638,120,116],[424,1642,120,116],[352,1774,120,116],[0,356,312,170],[652,342,312,170],[314,512,312,170],[0,186,324,168],[326,342,324,168],[326,172,332,168],[660,172,332,168],[670,0,342,170],[326,0,342,170],[0,0,324,184]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_003 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_005 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_006 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLegBack_excited_007 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_0010001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_0010002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_0020002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_0030002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_0040002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_excited_001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_excited_002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_excited_003 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_excited_005 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.ZebraFrontLeg_excited_006 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0010001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0010002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0020001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0030001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0030002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0040001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_0040002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_005 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_005png0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_excited_004 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHead_excited_004png0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLegBack0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLegBack0002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLegBack_001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg0002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg_0030001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg_0030002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg_0040001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg_0040002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.ZebraHindLeg_excited_004 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.ZebraNeck0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.ZebraNeck0002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.ZebraNeck_excited_004 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0127 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0129 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0132 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0135 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0138 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0142 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0145 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0148 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0151 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTail_looping0155 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0010002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0010003 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0010004 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0020001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0020002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0030001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0030002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0040001 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_0040002 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(65);
}).prototype = p = new cjs.Sprite();



(lib.ZebraTorso_excited_004 = function() {
	this.spriteSheet = ss["MWzebra_atlas_"];
	this.gotoAndStop(66);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.zebra_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AETBeQAwgdAdgiQAJgMAGgKQACgrgsgsQhZhXjkAAQhoAHhjAfQjHA9AgBzQAcAYBPAkQCFA8CbgDIAEAAQABAAABAAQCIgMBkg8g");
	this.shape.setTransform(36.7,16.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zebra_tummyGlow, new cjs.Rectangle(-2,-2,77.5,37.3), null);


(lib.zebra_maneMud_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{clean:1});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgCApQgDgEAAgDIgHABQgHAAgFgFQgEgFAAgGIAAgCQgHgBgFgLQgDgIAAgIIgCgKIgCgJQAAgIAMgFQANgFAEAQQADAKALACQAFABAEAFQAEAEgBADQAHAAAEADIAGADQAGAAAEACQADADABADQADgBADAEIACAEIABAFQAAAFgQAKQgQALgMAAQgEAAgCgEg");
	this.shape.setTransform(4.8,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,9);


(lib.zebra_maneMud_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"clean":1});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAGApQgDgEAAgDIgGABQgIAAgFgFQgEgFAAgGIAAgCIgCAAQgIAAgJgFQgGgDgBgEIgDgDQAAgCgBgDIgFgSIAAgIQAAgNANAEIAGACQACgEAIgDQAMgFAFAQQADAKAJACQAGABAEAFQAFAEgCADQAHAAAFADIAFADQAHAAAEACQADADAAADQAEgBADAEIACAEIAAAFQAAAFgPAKQgRALgLAAQgEAAgDgEg");
	this.shape.setTransform(5.6,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,11.3,9);


(lib.zebra_maneMud_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"clean":1});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgCApQgDgEAAgDIgHABQgHAAgFgFQgEgFAAgGIAAgCQgHgBgFgLQgDgIAAgIIgCgKIgCgJQAAgIAMgFQANgFAEAQQADAKALACQAFABAEAFQAEAEgBADQAHAAAEADIAGADQAGAAAEACQADADABADQADgBADAEIACAEIABAFQAAAFgQAKQgQALgMAAQgEAAgCgEg");
	this.shape.setTransform(4.8,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,9);


(lib.zebra_maneMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:34,"clean":40});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_34 = function() {
		/* stop();*/
	}
	this.frame_40 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(34).call(this.frame_34).wait(6).call(this.frame_40).wait(6));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AArAoQgIgOgOgGIgbgQQgXgLgGAAQgGAAgkAIQgLAAgGgRQgDgLAAgNQAAgOAQAGQAQAFACAHIARABIAFgDQAFgDAFAAIATADQAFABAEADQADACACAAQAEAAAFgEQAEgDADAAQAIAAADAMQACANAGAAQAPAAAAALIAAADQAuAHAAATQAAAFgLAJQgNALgRAAQgIAAgGgLg");
	this.shape.setTransform(9.8,5.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,19.6,10.2);


(lib.zebra_maneGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AFdA7QgOgGgDgIQgEgMgGAAQgDAAgEACQgEADgBAAQgBAAgDgIQgFgJgGAAQgCAAgFACQgGADgDABQgDgDABgKQgBgKgNAAQgFAAgKAGQgGAEgDABQgCgCgCgBQgBgEgBgEQgDgLgIAAQgFAAgHAGQgCACgDABQAAgCAAgCQgDgHgJAAIgBAAQgHgKgFAAQgFAAgDACQgFgGgIAAQgFAAgEABQAAgBAAgBQgEgQgMAAQgEAAgKAHQgLAAgDAHQgBAAAAAAQgFAAgCAAQgDgEgFgBQgDgEgCgFQgEgOgIAAQgGAAgNASQAAAAgCAAQgBAAgCAAQAAgBgBgBQgCgCgCgEQgIgKgFAAQgCAAgKAHQgDACgCACQgDgBgFAAQgBAAgCABQgCgFgEgHQgHgQgHAAQgFAAgGAGQgGAFgGAAQgCAAgFgFQgDgGgEAAQgFAAgFAHQgCACgBABQgDgCgEgBQAAgCAAgBQgFgKgJAAQgGAAgGAGQgEACgDAFQgCgCgCgBQgCgEgCgGQgFgKgHAAQgFAAgFAFQgGgNgHACQgHACgEAMQgEgGgHAAQgJAAgJAGIgBAAQAAAAgBAAQgEgBgHAFQgCABgCACQgBABgBABQgDACgCACQgMgRgUAYQgngQgIAkQgBAAAAAAQgDgCgCABQgBAAAAABQgHADAAALQAAADAAADQAAADgBADQgBACgCABQgQAEADAKIABACQgGADgFAEQgEACgDACQgLAHgFAGQgBACgBACQAAAAAAABQgCACAAACQgBAEABADQABADAFADQADACAFADQAEABLBAlQgKgkgDAAg");
	this.shape.setTransform(26.3,12.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zebra_maneGlow, new cjs.Rectangle(-11.9,1.2,76.4,23), null);


(lib.zebra_legMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":28,"clean":52});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.legMud.push(this);
		if (gameVars.legMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_28 = function() {
		/* stop();*/
	}
	this.frame_52 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(28).call(this.frame_28).wait(24).call(this.frame_52).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhZCtIgFgTIgEgBQAAAMgCAIQgFAQgPAAQgRAAgHgXQgEgMgCgTQgkgBgGgOQgDgHAAgOQgeAAgMgxQgHgdAAgjQAAgHAEgIIAAgCQAAh3BGgzQBGg0A1AsQAdAZAigaQAigaAIA3QAIA4BNgdQBOgcAPBTQAPBUgJgBQgIAAgRANQgQANgCAGQgBAbgIAPQgOAcg5AJQgGAfgNAVQgYApgxAAQgiAAgNgWIgIAWQgRAqgOAAQgQAAgOg5g");
	this.shape.setTransform(11.5,68);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13,45,49.1,46);


(lib.zebra_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ALVHAQAHiTAVgEQAWgFgMgvQgLgvgHgxQgHgxgNg8QgNg7gCguQgBgvgdgXQgKgHgIgIQgOgMgLgNQABgBAAgBQgBgEgGgCQhMhgAyh4QAzh5ioAGQlwAUCSCvQAqBMAUA5QAHATAHARQATA1AOApQAPAqACBSQACBSgnA/QggAygQAJQgEABgEABQgEAAAAACQgPAHgOATQgWAeAAAUQAAALAOALQAQAOAYAAQAtAAAZgPQAJgFAFgFQAGAAAEgQQAGgWAGgmQAGgnACgIQACgJALgNQAHgJANgFQAHgDABgSQABgSARgrQASgrAFgOQAGgNAGgmQAGgpAAgMQABgegKgUQAAgBAAgBQAEAFAEAFIAAAAQAAACAEADQAMAOAMAPQATAYAQAXIAAAAIADAJQABgBABgBQAMARAKAQQAAACAAABQAAAGADAAIABgCQAkA+ALAzQAZB2g4A8QgZAagHAOQgLAJgLAPQgdAnAAAbQAAAOASAPQAWASAgAAQA6AAAigTQAZgPAAgNQAAgKgCgKgALGHAIAJgHQAAAEADAGIABAAQABgCABgBAJNF6QgCAFAAADApuntQgrgFgaATQgMAFgIAIQgmAcAHA/QAJBWASBBQATBCgGBRQgGBJAQBCQACAGABAHQAGAUAEASQALAvADAiQAFAugXAVQgKAJgGAFQgEACgFACQgMAGAAADQgCABgCABQgWAHgMAYQgMAXAFADQAEADAOADQAQADAMAAQA8AAACgRQABgEAAgFQAJgHAAgYQABgUAFgLQAEgGAOgLQAOgLAAgGQABgFgEgXQgEgXAAgCQgHgkACggQAAgDABgDQACgUALgZQAFgMAIgOQACgFADgFQAZBEAUBFQAJAjARAqQARAqgBAUQAAAIgEAMQgDAIgCADQgCAFgCAEQgCAEgHAGQgFAFgOAMQgCAAgCABQgRAHABADQAAAAABABQgJAGgIAKQgLANgGARQgFAPACACQAaAQA2gEQAygDAAgJQAAgHgCgJQANgYgCgdQgDgiAJgKQATgPADgKQABgDgJgTQgKgVAAgDQgNg5gGgzQgEgpgDhGQABgFABgEQAKgmgNgjQAAgEgDgGQgeg/ABhBQAAgTAIgSQABgCABgCQAXgYgFglQgEgcgFgbQgNhGgZgjQgggtg+gHg");
	this.shape.setTransform(-13.2,87.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zebra_legGlow, new cjs.Rectangle(-91.9,34.2,157.5,107), null);


(lib.zebra_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AmoivQgggIgPAKQgdAUAgB9QAfB9CnBSQBHAiCRgIQEhgPA5iZQA5iYBbgvQBbgwhaAFQhZAEglADQglADhHAOQhHAPg1AUQgVAHheAIQicANjsg5g");
	this.shape.setTransform(49.6,17.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zebra_backGlow, new cjs.Rectangle(-0.9,-5.2,101.2,45.3), null);


(lib.zeb_lid = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D5D5D5").s().p("AgUAVQgGgGgCgHQASAPAngPQgCAHgGAGQgJAKgMgBQgLABgJgKgAgdAAQAAgMAJgJQAJgIALgBQAMABAJAIQAIAJABAMQgegSgdASg");
	this.shape.setTransform(3,3.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zeb_lid, new cjs.Rectangle(0,0,5.9,6.1), null);


(lib.zeb_close_lid = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D5D5D5").s().p("AgUAVQgJgIAAgNQAAgMAJgJQAJgIALgBQAMABAJAIQAIAJABAMQgBANgIAIQgJAKgMgBQgLABgJgKg");
	this.shape.setTransform(3,3.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.zeb_close_lid, new cjs.Rectangle(0,0,5.9,6.1), null);


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AETBeQAwgdAdgiQAJgMAGgKQACgrgsgsQhZhXjkAAQhoAHhjAfQjHA9AgBzQAcAYBPAkQCFA8CbgDIAEAAQABAAABAAQCIgMBkg8g");
	this.shape.setTransform(36.7,16.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(-2,-2,77.5,37.3), null);


(lib.blueglowmane = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AFdA7QgOgGgDgIQgEgMgGAAQgDAAgEACQgEADgBAAQgBAAgDgIQgFgJgGAAQgCAAgFACQgGADgDABQgDgDABgKQgBgKgNAAQgFAAgKAGQgGAEgDABQgCgCgCgBQgBgEgBgEQgDgLgIAAQgFAAgHAGQgCACgDABQAAgCAAgCQgDgHgJAAIgBAAQgHgKgFAAQgFAAgDACQgFgGgIAAQgFAAgEABQAAgBAAgBQgEgQgMAAQgEAAgKAHQgLAAgDAHQgBAAAAAAQgFAAgCAAQgDgEgFgBQgDgEgCgFQgEgOgIAAQgGAAgNASQAAAAgCAAQgBAAgCAAQAAgBgBgBQgCgCgCgEQgIgKgFAAQgCAAgKAHQgDACgCACQgDgBgFAAQgBAAgCABQgCgFgEgHQgHgQgHAAQgFAAgGAGQgGAFgGAAQgCAAgFgFQgDgGgEAAQgFAAgFAHQgCACgBABQgDgCgEgBQAAgCAAgBQgFgKgJAAQgGAAgGAGQgEACgDAFQgCgCgCgBQgCgEgCgGQgFgKgHAAQgFAAgFAFQgGgNgHACQgHACgEAMQgEgGgHAAQgJAAgJAGIgBAAQAAAAgBAAQgEgBgHAFQgCABgCACQgBABgBABQgDACgCACQgMgRgUAYQgngQgIAkQgBAAAAAAQgDgCgCABQgBAAAAABQgHADAAALQAAADAAADQAAADgBADQgBACgCABQgQAEADAKIABACQgGADgFAEQgEACgDACQgLAHgFAGQgBACgBACQAAAAAAABQgCACAAACQgBAEABADQABADAFADQADACAFADQAEABLBAlQgKgkgDAAg");
	this.shape.setTransform(26.3,12.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmane, new cjs.Rectangle(-11.9,1.2,76.4,23), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ALVHAQAHiTAVgEQAWgFgMgvQgLgvgHgxQgHgxgNg8QgNg7gCguQgBgvgdgXQgKgHgIgIQgOgMgLgNQABgBAAgBQgBgEgGgCQhMhgAyh4QAzh5ioAGQlwAUCSCvQAqBMAUA5QAHATAHARQATA1AOApQAPAqACBSQACBSgnA/QggAygQAJQgEABgEABQgEAAAAACQgPAHgOATQgWAeAAAUQAAALAOALQAQAOAYAAQAtAAAZgPQAJgFAFgFQAGAAAEgQQAGgWAGgmQAGgnACgIQACgJALgNQAHgJANgFQAHgDABgSQABgSARgrQASgrAFgOQAGgNAGgmQAGgpAAgMQABgegKgUQAAgBAAgBQAEAFAEAFIAAAAQAAACAEADQAMAOAMAPQATAYAQAXIAAAAIADAJQABgBABgBQAMARAKAQQAAACAAABQAAAGADAAIABgCQAkA+ALAzQAZB2g4A8QgZAagHAOQgLAJgLAPQgdAnAAAbQAAAOASAPQAWASAgAAQA6AAAigTQAZgPAAgNQAAgKgCgKgALGHAIAJgHQAAAEADAGIABAAQABgCABgBAJNF6QgCAFAAADApuntQgrgFgaATQgMAFgIAIQgmAcAHA/QAJBWASBBQATBCgGBRQgGBJAQBCQACAGABAHQAGAUAEASQALAvADAiQAFAugXAVQgKAJgGAFQgEACgFACQgMAGAAADQgCABgCABQgWAHgMAYQgMAXAFADQAEADAOADQAQADAMAAQA8AAACgRQABgEAAgFQAJgHAAgYQABgUAFgLQAEgGAOgLQAOgLAAgGQABgFgEgXQgEgXAAgCQgHgkACggQAAgDABgDQACgUALgZQAFgMAIgOQACgFADgFQAZBEAUBFQAJAjARAqQARAqgBAUQAAAIgEAMQgDAIgCADQgCAFgCAEQgCAEgHAGQgFAFgOAMQgCAAgCABQgRAHABADQAAAAABABQgJAGgIAKQgLANgGARQgFAPACACQAaAQA2gEQAygDAAgJQAAgHgCgJQANgYgCgdQgDgiAJgKQATgPADgKQABgDgJgTQgKgVAAgDQgNg5gGgzQgEgpgDhGQABgFABgEQAKgmgNgjQAAgEgDgGQgeg/ABhBQAAgTAIgSQABgCABgCQAXgYgFglQgEgcgFgbQgNhGgZgjQgggtg+gHg");
	this.shape.setTransform(-13.2,87.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-91.9,34.2,157.5,107), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AmoivQgggIgPAKQgdAUAgB9QAfB9CnBSQBHAiCRgIQEhgPA5iZQA5iYBbgvQBbgwhaAFQhZAEglADQglADhHAOQhHAPg1AUQgVAHheAIQicANjsg5g");
	this.shape.setTransform(49.6,17.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-0.9,-5.2,101.2,45.3), null);


(lib.ZebraTorso_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ZebraTorso_excited_004();
	this.instance.parent = this;
	this.instance.setTransform(-79,-49.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraTorso_excited_004_1, new cjs.Rectangle(-79,-49.2,162,92), null);


(lib.ZebraTorso_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.ZebraTorso_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-78,-41.4,0.5,0.5);

	this.instance_1 = new lib.ZebraTorso_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-78,-41.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-78,-42.5,171,86.1);


(lib.ZebraTorso_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.ZebraTorso_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-78.4,-41.9,0.5,0.5);

	this.instance_1 = new lib.ZebraTorso_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-78.4,-41.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-78.4,-41.9,166,84);


(lib.ZebraTorso_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.ZebraTorso_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-77.9,-41.4,0.5,0.5);

	this.instance_1 = new lib.ZebraTorso_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-77.9,-41.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-77.9,-41.4,162,84);


(lib.ZebraTail_looping = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{loopback:124});

	// Layer 5
	this.instance = new lib.ZebraTail_looping0001();
	this.instance.parent = this;
	this.instance.setTransform(-46,-15,0.5,0.5);

	this.instance_1 = new lib.ZebraTail_looping0127();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-46,-15,0.5,0.5);

	this.instance_2 = new lib.ZebraTail_looping0129();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-46,-15,0.5,0.5);

	this.instance_3 = new lib.ZebraTail_looping0132();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-46,-15,0.5,0.5);

	this.instance_4 = new lib.ZebraTail_looping0135();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-46,-15,0.5,0.5);

	this.instance_5 = new lib.ZebraTail_looping0138();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-46,-15,0.5,0.5);

	this.instance_6 = new lib.ZebraTail_looping0142();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-46,-15,0.5,0.5);

	this.instance_7 = new lib.ZebraTail_looping0145();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-46,-15,0.5,0.5);

	this.instance_8 = new lib.ZebraTail_looping0148();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-46,-15,0.5,0.5);

	this.instance_9 = new lib.ZebraTail_looping0151();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-46,-15,0.5,0.5);

	this.instance_10 = new lib.ZebraTail_looping0155();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-46,-15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},126).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},4).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},4).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance}]},3).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-46,-15,60,58);


(lib.ZebraNeck_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraNeck_excited_004();
	this.instance.parent = this;
	this.instance.setTransform(-26.6,-45.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraNeck_excited_004_1, new cjs.Rectangle(-26.6,-45.5,74,91), null);


(lib.ZebraHindLegBack_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.ZebraHindLegBack_001();
	this.instance.parent = this;
	this.instance.setTransform(-32.8,-66.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraHindLegBack_001_1, new cjs.Rectangle(-32.8,-66.6,54,126), null);


(lib.ZebraHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,"clean":2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:155,"final":156,final_loop:157});

	// Layer 5
	this.instance = new lib.ZebraHindLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-21.6,-60.9,0.5,0.5);

	this.instance_1 = new lib.ZebraHindLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-21.6,-60.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.7,-60.9,52.2,120);


(lib.ZebraHindLeg_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.ZebraHindLeg_excited_004();
	this.instance.parent = this;
	this.instance.setTransform(-28.9,-62.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraHindLeg_excited_004_1, new cjs.Rectangle(-28.9,-62.9,70,121), null);


(lib.ZebraHindLeg_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.ZebraHindLeg_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-48.5,-58.3,0.5,0.5);

	this.instance_1 = new lib.ZebraHindLeg_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-48.5,-58.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.5,-58.3,81,131);


(lib.ZebraHindLeg_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.ZebraHindLeg_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-42.2,-61.9,0.5,0.5);

	this.instance_1 = new lib.ZebraHindLeg_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42.2,-61.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.2,-61.9,78,135);


(lib.ZebraHead_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ZebraHead_excited_004png0001();
	this.instance.parent = this;
	this.instance.setTransform(-30.7,-39.1,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_excited_004();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-30.7,-39.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.7,-39.1,63,75);


(lib.ZebraHead_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 4
	this.instance = new lib.ZebraHead_005png0001();
	this.instance.parent = this;
	this.instance.setTransform(-36.1,-40.4,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_005();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-36.1,-40.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-36.4,-40.6,69.3,84.3);


(lib.ZebraHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 4
	this.instance = new lib.ZebraHead_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-35,-40,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-35,-40,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-35,-40,70,80);


(lib.ZebraHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 4
	this.instance = new lib.ZebraHead_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-33.2,-39.9,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-33.2,-39.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.2,-39.9,68,79);


(lib.ZebraHead_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 4
	this.instance = new lib.ZebraHead_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-31.2,-39.1,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-31.2,-39.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.2,-39.1,64,75);


(lib.ZebraHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 3
	this.instance = new lib.ZebraHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-29.8,-38.7,0.5,0.5);

	this.instance_1 = new lib.ZebraHead_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-29.8,-38.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).wait(152));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-29.9,-38.8,62.2,75.1);


(lib.ZebraFrontLegBack_excited_007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_007();
	this.instance.parent = this;
	this.instance.setTransform(-17,-30,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_007_1, new cjs.Rectangle(-17,-30,58,63), null);


(lib.ZebraFrontLegBack_excited_006_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_006();
	this.instance.parent = this;
	this.instance.setTransform(-19,-39,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_006_1, new cjs.Rectangle(-19,-39,44,88), null);


(lib.ZebraFrontLegBack_excited_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_005();
	this.instance.parent = this;
	this.instance.setTransform(-20,-43,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_005_1, new cjs.Rectangle(-20,-43,50,95), null);


(lib.ZebraFrontLegBack_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-24,-28,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_003_1, new cjs.Rectangle(-24,-28,42,85), null);


(lib.ZebraFrontLegBack_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-14,-34,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_002_1, new cjs.Rectangle(-14,-34,32,96), null);


(lib.ZebraFrontLegBack_excited_0001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_0001();
	this.instance.parent = this;
	this.instance.setTransform(-20,-38,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_0001_1, new cjs.Rectangle(-20,-38,38,92), null);


(lib.ZebraFrontLegBack_excited_001b = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AghAZIAAgaQAAgCAAgBQAAgBAAAAQAAgBAAAAQAAAAAAAAIAPgHQASgLADAAQAEAAAOAHQANAGAAAEIAAAAQgBADgHAAIgCgCIgEAJIAAAAIgDgIQAAABAAAAQAAAAgBAAQAAABAAAAQAAAAgBAAIAAAAIgBAFIgBAAIgDgFIgBAAIAAABQgDAEAAADIgBAAIgDgFIAAALIgBABIgBgJIAAgHIgBACIAAAAIgCAGQgDAKgDgBIgCgGIgBgEQgDAJABADIgBABIgCgDIAAAEIgBACIgBAAIAAgCIgBAAIgBAAIgBACIAAAAIgBABQgCgEgBgEIgBAGIgBAAQgBAAAAABQAAAAgBAAQAAAAAAAAQAAAAgBgBIAAAAIgCAGIAAABg");
	this.shape.setTransform(2.8,41);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("Ag6ASQgBgLADgNIABgDQAAABAAAAQAAAAABAAQAAAAAAgBQAAAAABAAIABAAIABgGQABAEACAEIABgBIAAAAIABgCIABAAIABAAIAAACIABAAIABgCIAAgEIACADIABgBQgBgDADgJIABAEIACAGQADABADgKIACgHIAAAAIABgCIABAIIABAJIABgBIAAgLIADAFIABAAQAAgDADgFIAAgBIABAAIADAGIABAAIABgGIAAAAQABAAAAAAQAAgBABAAQAAAAAAAAQAAgBAAAAIADAJIAAAAIAEgKIABACQAHAAABgDIAAgBIAEACQAYAIANAaQANAYgGADQgEADgPADQgRAEgNAAQg/AAgDgTg");
	this.shape_1.setTransform(5.3,43.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer 1
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AATGIQgFgEADgOQADgKgFgSQgDgQABgFQgDgFgFgNQgDgNAMgNQAKgMAFgOQABgKAoirQgQgGgMggQADAFgDgRQgBgIgDgKIgDABQhihMhKhyIgNgmQgThAAHgjQAIgtA0gTQAxgRAnAYQAPAIAPATQAKAKAPAZQAJAOAMAfQALAgAJBWQAJBXBBBHQASAsgUALQg1BNgJA5QgXCEAPAeQgugEAKAIQgQgCgGAYQgBAJgEAAIgCAAg");
	this.shape_2.setTransform(-2.6,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_001b, new cjs.Rectangle(-19.1,-34.7,33,82.3), null);


(lib.ZebraFrontLegBack_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLegBack_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-17,-41,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLegBack_excited_001_1, new cjs.Rectangle(-17,-41,57,71), null);


(lib.ZebraFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 4
	this.instance = new lib.ZebraFrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-14,-46,0.5,0.5);

	this.instance_1 = new lib.ZebraFrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-14,-46,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},152).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.9,-46,44,100);


(lib.ZebraFrontLeg_excited_006_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLeg_excited_006();
	this.instance.parent = this;
	this.instance.setTransform(-21,-13,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLeg_excited_006_1, new cjs.Rectangle(-25.8,-13.9,68.8,65), null);


(lib.ZebraFrontLeg_excited_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLeg_excited_005();
	this.instance.parent = this;
	this.instance.setTransform(-10,-13,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLeg_excited_005_1, new cjs.Rectangle(-10,-13,57,91), null);


(lib.ZebraFrontLeg_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLeg_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-19,-15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLeg_excited_003_1, new cjs.Rectangle(-19,-15,41,90.1), null);


(lib.ZebraFrontLeg_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ZebraFrontLeg_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-16.6,-15.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLeg_excited_002_1, new cjs.Rectangle(-17.5,-15.4,39,102), null);


(lib.ZebraFrontLeg_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ZebraFrontLeg_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-10.5,-12.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraFrontLeg_excited_001_1, new cjs.Rectangle(-10.5,-12.9,57,71), null);


(lib.ZebraFrontLeg_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.ZebraFrontLeg_0040002();
	this.instance.parent = this;
	this.instance.setTransform(-16.7,-13,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.7,-13,51.2,98);


(lib.ZebraFrontLeg_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.ZebraFrontLeg_0030002();
	this.instance.parent = this;
	this.instance.setTransform(-16,-15.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.3,-15.1,51.5,101);


(lib.ZebraFrontLeg_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.ZebraFrontLeg_0020002();
	this.instance.parent = this;
	this.instance.setTransform(-17.1,-16.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.7,-16.5,52.1,102.1);


(lib.StripesTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F0F56").s().p("AgkBYQACgKAcgFQAbgGAAAKQAAAKgLAAQgKAAgTAGIgKACQgHAAAAgHgAggAmQAAgMAcgCQAbgCAAAPQAAAHgKgBQgKgBgUADIgIAAQgLAAAEgHgAAGgDIgWgGQgJgCAEgJQAFgKAUAHQAVAGABAHQABAHgDACIgDAAQgFAAgKgCgAARgnQgRgEgGAAQgHAAAHgMQAGgNAOAHQAQAHACAKQACAGgIAAIgJgBgAAHhMQAGgGADgGQADgGAJAAQAJAAAAAHQAAAIgFAEQgFADgNABIgCAAQgKAAAFgFg");
	this.shape.setTransform(-0.1,-0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.StripesTail, new cjs.Rectangle(-3.7,-9.7,7.3,19), null);


(lib.StripesHindLeg_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F0F56").s().p("AAeANIgagIQgXAJgPgYIgCgCQgBgGAEAEIAKAJIAHAFQAJADAHgCIAHgBIACABQAGAEAIgBIABAAQABAAAAAAQABAAAAgBQABAAAAAAQABAAAAAAQAAgBAAAAQAAAAAAgBQAAAAABAAQAAAAAAAAIgIgDQgIgEgCgCQgBgDAIAEQAIADADAAQAHgBABAEQACARgGABIgBAAQAAAAAAgBQgBAAAAAAQAAgBgBgBQAAAAAAgBg");
	this.shape.setTransform(-28.9,38.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0F0F56").s().p("AAfAOQgGgFgEgBIgSgBQgOgBgEgCQgFgDgJgIQgIgIAAgCQgBgEAJAGQAHAGACAEQADAEASACQAUADgCgEIgCgGQgFgEgHgCIADgBQAOgDAIANQAGAHACAKQAAAFgCABg");
	this.shape_1.setTransform(-26.3,34.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 4
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#0F0F56").s().p("AAbAMIgPgMQgJgHgeADQgDgBgEgFIgFgFQAAgFAEACIAJAFQAHAEAJgEQAIgEAIAFQAKAEABACIAXAQIgCAJIgLgHg");
	this.shape_2.setTransform(-24.6,30.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 5
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#0F0F56").s().p("AArASIgDgGQAAgDgJgHQgJgGgMABQgKAFgMgCIgZgHQgLgFgBgGQgCgGAWAJQAVAJAGgCQADgDAOAAQAMABAIAEIALAFQADABABALIAAAFQgBAFgDAAQAAAAAAAAQgBAAAAgBQgBAAAAAAQgBgBAAgBg");
	this.shape_3.setTransform(-27.8,24.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

	// Layer 6
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#0F0F56").s().p("AgLAMQgFgDgDgGIgDgFIgCgFQgDgDgEgBIgDgDQAAgEAGAAQAGACAFAGIALALIAJAHQAEADAJAAIAMAAQAHAAAAABQABADgFACIgYACQgLgCgHgFg");
	this.shape_4.setTransform(-19.6,23);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(1));

	// Layer 7
	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#0F0F56").s().p("AA7AmIgIgBQgPgDgVgKQgUgLgFgJQgGgJgYgKQgagLACgDQABgEAGgCIAKgBIAJgBQAVACAQAQIANASQAIALAHAGQALAMAZAGIACACQAAABAAAAQAAAAgBAAQAAABgBAAQgBAAgBAAIgCAAg");
	this.shape_5.setTransform(-21,17.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_5).wait(1));

	// Layer 8
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#0F0F56").s().p("ABDAaQgRgEgRADQgRADgZgLQgNgFgHgOQgMgKgVgCQgWgCABgEQABgEAEgCQAGgBASABQAYACANALQAKAMAMAFQAOAGAgAEQAhADAAAHQgBAEgGAAIgKgCg");
	this.shape_6.setTransform(-15.3,11.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(1));

	// Layer 9
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#0F0F56").s().p("AAJAIQgWgJgPgMQgPgMgGADIgLAEQgEAAgCACQgBACgHgBQgJgBAAgDQAJAAAYgGQAXgHAQAKQAPAKAGAGQAFAFAiALQAjALgBADQAAABAAAAQAAABAAAAQAAABgBAAQAAABgBAAIgFABQgXgCgsgTg");
	this.shape_7.setTransform(-8.8,7.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_7).wait(1));

	// Layer 10
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#0F0F56").s().p("ABKAkQgDgBgBgDQgIgQgVgCQgqgDgjgYIgSgLQgMgHgJADIgKADIAAgBIAAgBIABgCIAAAAIAAAAIACgCIACgDQAAAAABgBQAAAAAAAAQABAAAAAAQABAAAAAAQAggCAQALIAfAVQAPAHARgCQARgCAMAEQAMAEAGANQAHAMgDACQgDADgFAAIgDAAg");
	this.shape_8.setTransform(-12.4,1.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(1));

	// Layer 11
	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#0F0F56").s().p("AB9ANIgCgBQgTgEgdACIgEABQggADgnAOIgBAAQgIACgJAAIgBAAQg2gDglggIgBgBQgPgNgXAEIgBAAIAAgBIgBAAIgBgBIAAAAIAAgBIAAgCIAAAAIABgBIAAgBIAAAAIABAAIABgBIAIgDIABgBIAEgDQAAAAAAgBQABAAAAAAQABgBAAAAQABAAABABQAxAIArAWIABAAQAiASAlgKQAzgMA0AIQAHABAFAFQAKALgGALIgBACQgIgPgRgFg");
	this.shape_9.setTransform(-7.1,-6.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_9).wait(1));

	// Layer 12
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#0F0F56").s().p("AATANIgNgNQgrgRAAgGIAmALQAmAMgCARIAAAEQAAABAAABQgBAAAAAAQgBABAAAAQgBAAgBAAQgEAAgKgLg");
	this.shape_10.setTransform(0.3,1.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_10).wait(1));

	// Layer 13
	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#0F0F56").s().p("ACeAxQACgIgFgHQgIgLgNgFQgJgEgLABQgmAEgigQQgMgEgpgBQgrgCgvgdQgvgegSgGIgSgGIAAgBIACgBIAAgBIACAAIAdAHQAdAHArAQQAqARAjADQAhAFAiACQAMABAMAGQAMAFAWAGQAWADASACQARABABADQAOAsgkAdQgGgMAFgSg");
	this.shape_11.setTransform(-2.3,-11.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_11).wait(1));

	// Layer 14
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#0F0F56").s().p("ACMAuIgKgGQgggHgjgLQgQgFgPgHQgtgWg3ABQgIAAgGgDQgigNgfgPIgSgCQgFgBABgDIAAgBIAAgBIACgBIADgBIAUACIADAAIABABIABABIACABIAVAKQAVAIAXACIAaABIAOAAQALAAAIADQAIADAFAAIAIADIAOAGQAQAGAQAGIAJAFQAjAOAmAJQAJACAGAEIADAEIAAABIABAAIAAABQAJAEAHAHIgIABQgLAAgMgHg");
	this.shape_12.setTransform(-5.9,-21.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_12).wait(1));

	// Layer 15
	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#0F0F56").s().p("AC6BHQgOgSgGgCIgEgCIgwgXQgfgOgUgMQgVgNgMgGQgLgHgXgKIgGgDQgvgRg0gFQgWgBgQgIIgKgDQgVgGgTACIgBAAIgCgBIgEAAIgBgBIAAgBIAKgHQAIgCAHABQAHgCAGABIAHgBIAKAAIAEAAIA7AEQAZACAhAGQAfAGAcAJQAcAIARAHQAHADAoAbIAsAbQAJAEAVATQADACAHA5QgFgCgPgSg");
	this.shape_13.setTransform(3.1,-34.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_13).wait(1));

	// Layer 16
	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#0F0F56").s().p("AC/BcQAEgFgBgGQgWACgVgEQgYgFgXgOQhFgrhPgZQgkgLgegUQgHgFgIgCQgzgLgegjIAAgCIABgBIABgCIAAAAIAAgBIAAgDQAAAAABgBQAAgBAAAAQABAAAAgBQABAAAAAAIACAAQASALAVAKIABAAQBmAXBEAeQBKAgAsAaQAZAPAQAIIATAIQAJAEAHAGIABABIABAAQABAIgEAHIgHAQIgHAEQgGgFAHgIg");
	this.shape_14.setTransform(0.2,-27.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_14).wait(1));

}).prototype = getMCSymbolPrototype(lib.StripesHindLeg_002, new cjs.Rectangle(-32.8,-43.5,56.6,83.8), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.hintBlocksSparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.sparkle2();
	this.instance.parent = this;
	this.instance.setTransform(16.6,-22.6,0.365,0.365,38.2,0,0,0,0.1);

	this.instance_1 = new lib.sparkle2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.8,20.6,0.365,0.365,83.2,0,0,-0.1,0.2);

	this.instance_2 = new lib.sparkle2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-10,-18.6,0.614,0.614,83.2,0,0,-0.2,0.1);

	this.instance_3 = new lib.sparkle2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-17.8,-7.1,0.614,0.614,-25.9);

	this.instance_4 = new lib.sparkle2();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-27.4,12.7,0.614,0.614,-10.9);

	this.instance_5 = new lib.sparkle1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(21.8,-14.5,0.614,0.614,73.9);

	this.instance_6 = new lib.sparkle1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-13.4,23.2,0.614,0.614,-152.4);

	this.instance_7 = new lib.sparkle1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-11.3,-26.9,0.614,0.614,-9.3);

	this.instance_8 = new lib.sparkle1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(24.3,6.7,0.615,0.615,-15);

	this.instance_9 = new lib.sparkle2();
	this.instance_9.parent = this;
	this.instance_9.setTransform(13.4,-12.4,0.614,0.614,51.9);

	this.instance_10 = new lib.sparkle1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-10.4,-2.6,0.614,0.614,-76.2);

	this.instance_11 = new lib.sparkle1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(4.9,12.4,0.614,0.614,152.9);

	this.instance_12 = new lib.sparkle1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-16.4,14.8,0.614,0.614,-157.2);

	this.instance_13 = new lib.sparkle2();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-1.6,-18.1,0.614,0.614,34.1);

	this.instance_14 = new lib.sparkle2();
	this.instance_14.parent = this;
	this.instance_14.setTransform(9.8,26.6,0.614,0.614,160.5,0,0,0,0.1);

	this.instance_15 = new lib.sparkle2();
	this.instance_15.parent = this;
	this.instance_15.setTransform(9.7,-21.6,0.614,0.614,14.5,0,0,0.1,0.2);

	this.instance_16 = new lib.sparkle2();
	this.instance_16.parent = this;
	this.instance_16.setTransform(26.6,-0.6,0.614,0.614,-52,0,0,0,0.1);

	this.instance_17 = new lib.sparkle2();
	this.instance_17.parent = this;
	this.instance_17.setTransform(21.2,19.8,0.614,0.614,114.3,0,0,0.1,0.3);

	this.instance_18 = new lib.sparkle2();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-26.2,-15.2,0.614,0.614,-118.7,0,0,0.1,0.4);

	this.instance_19 = new lib.sparkle1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-24.7,3.4,0.614,0.614,-112.5);

	this.instance_20 = new lib.sparkle1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(4.3,-8.2,0.614,0.614,14,0,0,0.1,0.4);

	this.instance_21 = new lib.sparkle2();
	this.instance_21.parent = this;
	this.instance_21.setTransform(13.9,12.9,0.614,0.614,108.3,0,0,0.1,0.1);

	this.instance_22 = new lib.sparkle2();
	this.instance_22.parent = this;
	this.instance_22.setTransform(14.7,-1.6,0.614,0.614,68.2,0,0,0.1,0.2);

	this.instance_23 = new lib.sparkle2();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-4.5,12.1,0.614,0.614,-171,0,0,0.1,-0.5);

	this.instance_24 = new lib.sparkle1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-10.2,-11.7,0.614,0.614,-52.8,0,0,0.1,0.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.hintBlocksSparkle, new cjs.Rectangle(-31.1,-31.5,62.1,62), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.Zebratummybubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(0.5,27.8,0.713,0.713,0,0,0,36,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(26,15.4,0.804,0.804,-158.2,0,0,36.1,11.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-21.6,18.3,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ZebraTorso_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 3
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(7.5,-13.9,0.713,0.713,0,0,0,36,11);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.4,-28,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(-20,-32.8,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ZebraTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.StripesTail();
	this.instance.parent = this;
	this.instance.setTransform(-1.6,-1.2);
	this.instance.shadow = new cjs.Shadow("#000000",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F0F56").s().p("AASBiQgRgPAAgZQgUAAABgTIAAgmIAAgBQgcgMALgjQAEgNgBgOQgBgHACgFQAEgKANgCQANAFAHAKQAGAIAEALQAUAgADApQABAPgEAFQAEAkgQAhQAAAAAAAAQgBABAAAAQAAAAgBAAQAAAAgBAAIgDgBg");
	this.shape.setTransform(-0.7,23.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgWB8QgNACgDAKQgNgjACghQgDgKAAgLQABhsA+hFIAHgHIABgBIABABIABAAQAtAngTA7QgDAPgIARIgZBAIgDAQIgEAYIAAABQADAagHAPQgIgKgOgFg");
	this.shape_1.setTransform(0.1,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZebraTail, new cjs.Rectangle(-8.3,-13.9,17,47.3), null);


(lib.ZebraNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Hair
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(-1.6,-13.1,0.478,0.478,30.7,0,0,35.9,11);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(37.7,-22.7,0.51,0.51,-115.2,0,0,36,11.3);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(16.2,-16.3,0.478,0.478,-10.5,0,0,35.9,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ZebraNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,glowclean:71,glowclean_loop:72,"final":73,"final_loop":74});

	// Layer 2
	this.instance = new lib.ZebraNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-23.2,-32.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2,-16.1,0.5,0.5,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(19,-18.9,0.75,0.75,0,0,0,47.6,10.1);

	this.instance_3 = new lib.ZebraNeck0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-23.2,-32.7,0.5,0.5);

	this.instance_4 = new lib.zebra_maneGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(14.1,-21.1,1,1,0,-3.1,176.9,26.2,12.6);

	this.glow = new lib.blueglowmane();
	this.glow.parent = this;
	this.glow.setTransform(14.1,-21.1,1,1,0,-3.1,176.9,26.2,12.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},58).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(171));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23.2,-32.7,80,83);


(lib.ZebraHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// mud
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(100.1,18.7,0.656,0.656,-72.4,0,0,35.9,11);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(92.2,2.9,0.64,0.64,99.4,0,0,36.1,11.2);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.8,15.9,0.656,0.656,0,0,0,35.9,11);

	this.instance_3 = new lib.Bubbles_together("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(-2.7,-17.3,0.64,0.64,171.8,0,0,36,11.1);

	this.instance_4 = new lib.Bubbles_together("synched",0,false);
	this.instance_4.parent = this;
	this.instance_4.setTransform(-14,-8.1,0.656,0.656,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ZebraHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":240,"final":241,"final_loop":242});

	// Layer 5
	this.instance = new lib.ZebraHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-34.1,-69.1,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(95.3,18.6,0.5,0.5,105,0,0,47.4,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0,17.6,0.5,0.5,0,0,0,47.8,9.4);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-16.3,9.8,0.499,0.499,125.8,0,0,50.2,5.1);

	this.instance_4 = new lib.ZebraHindLeg0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-34.1,-69.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},9).to({state:[{t:this.instance_4}]},226).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.1,-69.1,77,143);


(lib.ZebraFrontLeg_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":81,"glowclean":82,"glowclean_loop":83,"final":84,"final_loop":85});

	// Layer 2
	this.instance = new lib.ZebraFrontLeg_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-19.2,-19,0.5,0.5);

	this.instance_1 = new lib.ZebraFrontLeg_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-19.2,-19,0.5,0.5);

	this.instance_2 = new lib.zebra_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-58.3,34.2,1,1,0,0,180,-13.2,87.7);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(-58.3,34.2,1,1,0,0,180,-13.2,87.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},75).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(140));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-27.9,-19.8,53.7,105.9);


(lib.hintsparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(93));

	// Layer 1
	this.mouthSparkle = new lib.hintBlocksSparkle();
	this.mouthSparkle.parent = this;
	this.mouthSparkle.setTransform(-0.4,-0.1,0.294,0.294);
	this.mouthSparkle._off = true;

	this.timeline.addTween(cjs.Tween.get(this.mouthSparkle).wait(1).to({_off:false},0).wait(68).to({alpha:0},23).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11.8,22.5,23.5);


(lib.zebra_tummyMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(39.7,22.3,0.713,0.713,0,0,0,35.9,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(65.3,9.9,0.804,0.804,-158.2,0,0,36.1,11.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.7,12.8,0.713,0.713,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.zebra_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":69,"glowclean":70,"glowclean_loop":71,"final":72,"final_loop":73});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAMCFIhWgBQgegFgegHQgVgDgWgHQgBgEgHgDQgHAAgEgFIgMAAIgTgIIgDgFIgCgBIgFgCQgEAAAAgDIgFAAIgIgFIgFgFIgKgCQgYgRghgaQhOg8AAgYQAAgUAFgGQANgTAxAAQAjAAAPAZIADAGIAAgFQAAg+A5AVQAXAHARASIAIAKQAigJAYAAIAPADIAQADIAOgOQANgPAZAAQAPAAAPAEIAMADIARgLQASgLADgBIBXAAQBAAJAnAYQAUAMAHALQAGAAAGgFQAGgGATAAQAjAAAPASQAIAKADAMQAmACAJACIABAGQABAigaAOIgRAQIgBAAQgPAMgTALIgCgCIgBABQglAKgkATIgBACIgFAAIgFADQgsATgwAKQg+AXhCAAIgJgBg");
	this.shape.setTransform(40.5,13.4);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(61.9,14.6,0.621,0.621,0,0,0,47.8,9.2);

	this.instance_1 = new lib.left_over_bubbles("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(26.7,14.9,0.713,0.713,15,0,0,36.1,10.8);

	this.instance_2 = new lib.zebra_tummyGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(40.9,8.4,1,1,0,0,0,36.7,16.6);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(40.9,8.4,1,1,0,0,0,36.7,16.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},7).to({state:[{t:this.instance_1},{t:this.instance}]},56).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},154).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,81,26.7);


(lib.zebra_maneMud_002_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(4.8,4.4,0.247,0.247,172.6,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(8.3,7.1,0.33,0.33,160,0,0,35.8,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.zebra_maneMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(16.5,15.3,0.478,0.478,30.7,0,0,35.8,10.9);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(55.8,5.7,0.51,0.51,-115.2,0,0,35.9,11.3);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(34.3,12,0.478,0.478,-10.5,0,0,36,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.zebra_maneMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":28,"clean":52});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.maneMud.push(this);
		if (gameVars.maneMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_28 = function() {
		/* stop();*/
	}
	this.frame_52 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(28).call(this.frame_28).wait(24).call(this.frame_52).wait(12));

	// Layer 5
	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(33.9,6.9,0.636,0.636,-5.2,0,0,50.6,5.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(28).to({_off:false},0).to({_off:true},24).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhsBdQgBgLgCgCQgDACgFAIQgGAHgNAAQgDAAgEgCIgHgCQgCAAgFADQgFADgHAAQgKAAgIgLIgHgMQgLADgFgCIgDAGQgEAEgHAAQgKAAgCgGQgxAAAAgcQAAgVA5ggQA3gfAngHIAvgJQAegGAcgDQAUgCA9gMQAygKAnAAIAOACQACAAACgFQADgFAJAAQAFAAAFgCQAFgDAEAAIAIADQADgJAVgDQAUgCAJAFQALAGAQAIQAMAGAAAHIgCAHIABAQQgBAFgIAPQgDAFgIAEQgKAFgGgEIgNAKQgJAGgUAAQgDADgBAEIgBAIQgDAFgKgBQgKgBgDAFQgEALgEAHQgIANgKAAQgGAAgOgHIgPgHQAAAEgDADQgFAHgNAAQgIAAgHgFIgIgFQAEAJgLAQQgLARgOAAQgQAAgGgLQgEgNgCgDIgFAFQgEADgIAAQgJAAgHgFIgIgIQgBAGgDAEQgFAHgKAAIgIgBIgDgDQgDAEgEATQgFAQgPAAQgSAAgFgKg");
	this.shape.setTransform(28.8,10.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,57.6,20.7);


(lib.zebra_legMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.legMud.push(this);
		if (gameVars.legMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 4
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(121,94.5,0.656,0.656,-72.4,0,0,35.9,11);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(113.2,78.7,0.64,0.64,99.4,0,0,36.1,11.2);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(20.1,91.6,0.656,0.656,0,0,0,35.9,11);

	this.instance_3 = new lib.Bubbles_together("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(18.2,58.4,0.64,0.64,171.8,0,0,36,11.1);

	this.instance_4 = new lib.Bubbles_together("synched",0,false);
	this.instance_4.parent = this;
	this.instance_4.setTransform(7,67.6,0.656,0.656,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.zebra_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":28,"clean":52});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.legMud.push(this);
		if (gameVars.legMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_28 = function() {
		/* stop();*/
	}
	this.frame_52 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(28).call(this.frame_28).wait(24).call(this.frame_52).wait(12));

	// Layer 9
	this.instance = new lib.left_over_bubbles("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(2.1,81.2,0.626,0.626,-48,0,0,36.2,10.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(28).to({_off:false},0).to({_off:true},24).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhZCtIgFgTIgEgBQAAAMgCAIQgFAQgPAAQgRAAgHgXQgEgMgCgTQgkgBgGgOQgDgHAAgOQgeAAgMgxQgHgdAAgjQAAgHAEgIIAAgCQAAh3BGgzQBGg0A1AsQAdAZAigaQAigaAIA3QAIA4BNgdQBOgcAPBTQAPBUgJgBQgIAAgRANQgQANgCAGQgBAbgIAPQgOAcg5AJQgGAfgNAVQgYApgxAAQgiAAgNgWIgIAWQgRAqgOAAQgQAAgOg5g");
	this.shape.setTransform(11.5,68);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13,45,49.1,46);


(lib.zebra_backMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.backMud.push(this);
		if (gameVars.backMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(45.9,30,0.713,0.713,0,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(68.7,15.8,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_2 = new lib.Bubbles_together("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(18.3,11.1,0.713,0.713,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.zebra_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACDCsQgIgMgCgOIgGAAQgJAGgLAAQgMAAgKgSQgBAMgPALQgTAPgfAAQgeAAgYgpIgDAJQgHARgVAAQgVAAgOgVQgIgMgDgNIgEgfIgKABQgMAAgGgPIgCgFIgEADQgOAIgUAAQgXAAgagYQgNgNgKgNQgDABgFAFQgJAFgTAAQgkAAgPgUQgHgKgEgPQgFgJgXgOQgUgNgDgMQgBgHgVgsQgUgqAAgLIAAgEIAOAAQAhAAAgAEQAlAAAlAEIA6AAQAcAAAbAEQAwALAwAOIAFAEIAIAAIAFADIAFAAQAMAGARAAQAlAEAmABQBDABBEgJIAFgDIA3gDQA4gGA4gLQA6gLAtgiIgBAAIAAgHQAPANAEARQAHAogLASQgMASgPAIQgCARgIAOQgQAcgjAAQgMAAgJgEQgOAXgJADQgmAKgMATQgHAJgCAXQgDAtgRAlQgYA3gsAAQgdAAgPgZg");
	this.shape.setTransform(46.2,22.5);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(38.6,24.3,0.815,0.815,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(26.8,18.1,0.815,0.815,34.5,0,0,47.7,10.1);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(61.4,17.5,0.713,0.713,-165,0,0,36,10.8);

	this.instance_3 = new lib.zebra_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(43.5,25.3,1,1,0,-3.5,176.5,49.6,17.4);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(43.5,25.3,1,1,0,-3.5,176.5,49.6,17.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},58).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},153).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.2,2.8,92.1,39.5);


(lib.water_drops_011 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(182.5,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,93.4,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(2.4,41.5,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.ZebraTorso_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0});

	// Layer 4
	this.tummymud = new lib.zebra_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(4.5,21.4,1,1,0,0,0,40.5,13.3);

	this.backmud = new lib.zebra_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(6.1,-21.2,1,1,0,0,0,46.1,21.8);

	this.instance = new lib.ZebraTorso_0010002();
	this.instance.parent = this;
	this.instance.setTransform(-77.2,-43.3,0.5,0.5);

	this.instance_1 = new lib.ZebraTorso_0010003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-77.2,-43.3,0.5,0.5);

	this.instance_2 = new lib.ZebraTorso_0010004();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-77.2,-43.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-77.2,-43.3,156,85);


(lib.ZebraHindLeg_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_1 = new cjs.Graphics().p("AkVHeIgEgBQgRgGAFgnIABgIQAEgqACgpIAAgOQACgqAEgwIACgVQADgggHgjIgCgNQgGgpAZgaIAzgxQBPhQgniEIgEgNQgghxAjhqQAIgYALgXIABgEQALgZAOgVQA6hZBtgFQAhgCAfAEQC0AWANC3QADAmgEAkQgGA+gVAuQgQAhgcAiQgnAuhHA2IhFA0QhTBAhHBLIgTAUQg7BogIBLIAAAIQgKBwA6AxIACACQAwAogMAHQgNAIgogcIgBAAQgmAOgdBKQgXiFgWgGg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(1).to({graphics:mask_graphics_1,x:-3.1,y:-0.8}).wait(1));

	// mud
	this.instance = new lib.zebra_legMud_001();
	this.instance.parent = this;
	this.instance.setTransform(2.9,-38.1,1,1,0,0,0,24.4,24.8);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(1));

	// Layer 2
	this.instance_1 = new lib.StripesHindLeg_002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(2.6,-12.8);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2));

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ag7AxIgBAAIAAgBIgCgBIAAgCIgBgCIgBgDIAAgCIAFgWIAAgBQADgPgDABIAAAAQgEABAQgLIANgKIAUgPQAWgPAkAAIAJAGQAKAHACAFIAAADIgDABIAAABIgBADIgDAEIgBAEIAAACIgBABIgDgBIgBgBIgDgFIgEAAIgBAAIAAAAIgBAEIAAADIgBABIgDAAIgBAAIgEgDIgBgBIAAAAIgCABIAAAAIgBACIgCAJIgCABIgCgBIgBAAIgDgCIAAACIACAKIgBACIAAAAIgCgBIgEgIIgCgEIgDgGIgBABIAAAAIgBABIAAACIAAAGIgBAEQgBALgFABQAAAAgBAAQAAAAAAAAQAAAAgBAAQAAgBgBAAIgEgEIgEgDIgBgCIgBACQABAKACAEIgBADIgBAAQAAAAAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgCgBIAAACIABACIgBADIgBABIAAAAIgBgBIgBAAIgBAAIgCgBIAAAAIgBABIAAACIgBAAIgBABIgBAAIgBAAIgHgHIgCABIAAAFIgBABIgCAAIgBAAIgDgCIgBACIgBABIAAACIABAJIAAABIgCABIAAAAIgBgBIgCAAIgFgEIgCACIgBAGIgBAAIgBgBg");
	this.shape.setTransform(-20.9,55.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

	// Layer 3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("AAUBKQg1AAgigSQgYgOAAgNQAAgaATgcIABgBIAAAAQAOgVATgMQANgIARgFIABAAIABAAIAAAAQAYgGAXATQAMAJAKAOIACAEQAbAjAAAZIgBADQgBAMgPANIgCACQgUAQgfAAIgCAAg");
	this.shape_1.setTransform(-18.1,59.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(2));

	// Layer 1
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AkVHeIgEgBQgRgGAFgnIABgIQAEgqACgpIAAgOQACgqAEgwIACgVQADgggHgjIgCgNQgGgpAZgaIAzgxQBPhQgniEIgEgNQgghxAjhqQAIgYALgXIABgEQALgZAOgVQA6hZBtgFQAhgCAfAEQC0AWANC3QADAmgEAkQgGA+gVAuQgQAhgcAiQgnAuhHA2IhFA0QhTBAhHBLIgTAUQg7BogIBLIAAAIQgKBwA6AxIACACQAwAogMAHQgNAIgogcIgBAAQgmAOgdBKQgXiFgWgGg");
	this.shape_2.setTransform(-3.1,-0.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.2,-62.4,66,129.4);


(lib.Zebra = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:40,rest_stop:259,"clean":402,clean_stop:410,wet:412,wet_stop:428,excited:430,excited_stop:560});

	// timeline functions:
	this.frame_38 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_400 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_410 = function() {
		/* stop();
		*/
	}
	this.frame_428 = function() {
		/* stop();*/
	}
	this.frame_562 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(38).call(this.frame_38).wait(362).call(this.frame_400).wait(10).call(this.frame_410).wait(18).call(this.frame_428).wait(134).call(this.frame_562).wait(1));

	// Zebra tummy bubbles
	this.tummy_bubbles = new lib.Zebratummybubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(341.7,202.7,0.776,0.776,0,0,180,30.2,-2.1);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).to({_off:true},412).wait(151));

	// Zebra Torso_001_bubbles
	this.back_bubbles = new lib.ZebraTorso_001_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(341.7,202.7,0.776,0.776,0,0,180,30.2,-2.1);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},412).wait(151));

	// Zebra Hind Leg_bubbles
	this.legs_bubbles = new lib.ZebraHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(401.9,195.4,0.776,0.776,0,0,180,5.9,-43.1);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).to({_off:true},412).wait(151));

	// Zebra Neck_bubbles
	this.mane_bubbles = new lib.ZebraNeck_bubbles();
	this.mane_bubbles.parent = this;
	this.mane_bubbles.setTransform(316.8,192.7,0.776,0.776,0,0,180,-8.4,13.6);

	this.timeline.addTween(cjs.Tween.get(this.mane_bubbles).to({_off:true},412).wait(151));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(321.8,238.1,0.679,0.679);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(552).to({_off:false},0).wait(11));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(299.7,164.1,0.679,0.679);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(546).to({_off:false},0).wait(17));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(418.4,226.2,0.679,0.679);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(538).to({_off:false},0).wait(25));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(360.2,186.8,0.679,0.679);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(528).to({_off:false},0).wait(35));

	// Layer 2
	this.instance_4 = new lib.water_drops_011();
	this.instance_4.parent = this;
	this.instance_4.setTransform(347.6,204.2,0.5,0.5,0,0,180,92.4,49.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(412).to({_off:false},0).to({_off:true},18).wait(133));

	// Rhino Lines
	this.instance_5 = new lib.zeb_lid();
	this.instance_5.parent = this;
	this.instance_5.setTransform(271,182.7,1,1,0,0,0,3,3.1);
	this.instance_5._off = true;

	this.instance_6 = new lib.zeb_close_lid();
	this.instance_6.parent = this;
	this.instance_6.setTransform(271,182.7,1,1,0,0,0,3,3.1);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(60).to({_off:false},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},1).wait(96).to({_off:false},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},1).wait(32).to({_off:false},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},1).wait(96).to({_off:false,x:274.9,y:249.7},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},1).wait(78).to({_off:false,x:271,y:182.7},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},1).wait(181));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(61).to({_off:false},0).to({_off:true},2).wait(98).to({_off:false},0).to({_off:true},2).wait(34).to({_off:false},0).to({_off:true},2).wait(98).to({_off:false,x:274.9,y:249.7},0).to({_off:true},2).wait(80).to({_off:false,x:271,y:182.7},0).to({_off:true},2).wait(182));

	// Zebra Front Leg
	this.zebra_frontleg = new lib.ZebraFrontLeg_001();
	this.zebra_frontleg.parent = this;
	this.zebra_frontleg.setTransform(327.6,215.6,0.776,0.776,0,0,180);

	this.zebra_frontleg_1 = new lib.ZebraFrontLeg_002();
	this.zebra_frontleg_1.parent = this;
	this.zebra_frontleg_1.setTransform(327.6,215.6,0.776,0.776,0,0,180);

	this.zebra_frontleg_2 = new lib.ZebraFrontLeg_003();
	this.zebra_frontleg_2.parent = this;
	this.zebra_frontleg_2.setTransform(327.6,215.6,0.776,0.776,0,0,180);
	this.zebra_frontleg_2._off = true;

	this.zebra_frontleg_3 = new lib.ZebraFrontLeg_004();
	this.zebra_frontleg_3.parent = this;
	this.zebra_frontleg_3.setTransform(327.6,215.6,0.776,0.776,0,0,180);
	this.zebra_frontleg_3._off = true;

	this.zebra_frontleg_4 = new lib.ZebraFrontLeg_excited_002_1();
	this.zebra_frontleg_4.parent = this;
	this.zebra_frontleg_4.setTransform(336.4,190.1,0.774,0.793,0,16.9,-162.8);

	this.zebra_frontleg_5 = new lib.ZebraFrontLeg_excited_003_1();
	this.zebra_frontleg_5.parent = this;
	this.zebra_frontleg_5.setTransform(348.6,173,0.774,0.799,0,44.6,-131.4);
	this.zebra_frontleg_5._off = true;

	this.zebra_frontleg_6 = new lib.ZebraFrontLeg_excited_001_1();
	this.zebra_frontleg_6.parent = this;
	this.zebra_frontleg_6.setTransform(363.8,162.3,0.776,0.807,0,54.8,-117.6);
	this.zebra_frontleg_6._off = true;

	this.zebra_frontleg_7 = new lib.ZebraFrontLeg_excited_005_1();
	this.zebra_frontleg_7.parent = this;
	this.zebra_frontleg_7.setTransform(363.8,162.3,0.776,0.807,0,80.3,-92.1);

	this.zebra_frontleg_8 = new lib.ZebraFrontLeg_excited_006_1();
	this.zebra_frontleg_8.parent = this;
	this.zebra_frontleg_8.setTransform(360,158.3,0.776,0.852,0,-13.1,167.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.zebra_frontleg}]}).to({state:[{t:this.zebra_frontleg}]},40).to({state:[{t:this.zebra_frontleg}]},136).to({state:[{t:this.zebra_frontleg}]},78).to({state:[{t:this.zebra_frontleg}]},2).to({state:[{t:this.zebra_frontleg}]},2).to({state:[{t:this.zebra_frontleg}]},2).to({state:[{t:this.zebra_frontleg_1,p:{scaleY:0.776,skewX:0,x:327.6}}]},2).to({state:[{t:this.zebra_frontleg_2}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},12).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},14).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_3}]},10).to({state:[{t:this.zebra_frontleg_2}]},2).to({state:[{t:this.zebra_frontleg_1,p:{scaleY:0.776,skewX:0,x:327.6}}]},2).to({state:[{t:this.zebra_frontleg}]},2).to({state:[{t:this.zebra_frontleg}]},62).to({state:[{t:this.zebra_frontleg}]},10).to({state:[{t:this.zebra_frontleg}]},18).to({state:[{t:this.zebra_frontleg}]},28).to({state:[{t:this.zebra_frontleg_1,p:{scaleY:0.777,skewX:2.3,x:330}}]},2).to({state:[{t:this.zebra_frontleg_2}]},2).to({state:[{t:this.zebra_frontleg_3}]},2).to({state:[{t:this.zebra_frontleg_4}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_6}]},2).to({state:[{t:this.zebra_frontleg_6}]},2).to({state:[{t:this.zebra_frontleg_7,p:{scaleX:0.776,scaleY:0.807,skewX:80.3,skewY:-92.1,x:363.8,y:162.3}}]},2).to({state:[{t:this.zebra_frontleg_7,p:{scaleX:0.775,scaleY:0.806,skewX:55.9,skewY:-116.3,x:364.7,y:158.6}}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_8,p:{scaleY:0.852,skewX:-13.1,skewY:167.9}}]},2).to({state:[{t:this.zebra_frontleg_8,p:{scaleY:0.807,skewX:18.9,skewY:-153.4}}]},2).to({state:[{t:this.zebra_frontleg_6}]},2).to({state:[{t:this.zebra_frontleg_6}]},2).to({state:[{t:this.zebra_frontleg_7,p:{scaleX:0.776,scaleY:0.807,skewX:80.3,skewY:-92.1,x:363.8,y:162.3}}]},2).to({state:[{t:this.zebra_frontleg_7,p:{scaleX:0.775,scaleY:0.806,skewX:55.9,skewY:-116.3,x:363.5,y:159.7}}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_8,p:{scaleY:0.852,skewX:-13.1,skewY:167.9}}]},2).to({state:[{t:this.zebra_frontleg_8,p:{scaleY:0.807,skewX:18.9,skewY:-153.4}}]},2).to({state:[{t:this.zebra_frontleg_6}]},2).to({state:[{t:this.zebra_frontleg_5}]},2).to({state:[{t:this.zebra_frontleg_4}]},2).to({state:[{t:this.zebra_frontleg_2}]},2).to({state:[{t:this.zebra_frontleg_2}]},2).to({state:[{t:this.zebra_frontleg_1,p:{scaleY:0.777,skewX:2.3,x:330}}]},2).to({state:[{t:this.zebra_frontleg}]},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontleg).wait(256).to({scaleY:0.78,y:215.2},0).wait(2).to({scaleY:0.79,y:214.7},0).wait(2).to({scaleY:0.78,y:215.6},0).to({_off:true},2).wait(78).to({_off:false},0).wait(118).to({_off:true},2).wait(56).to({_off:false},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontleg_2).wait(264).to({_off:false},0).to({_off:true},2).wait(70).to({_off:false},0).to({_off:true},2).wait(124).to({_off:false,scaleY:0.78,skewX:4.5,x:332.4},0).to({_off:true},2).wait(46).to({_off:false},0).wait(2).to({_off:true},2).wait(49));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontleg_3).wait(266).to({_off:false},0).wait(14).to({scaleY:0.77,y:216},0).wait(2).to({scaleY:0.77,y:216.2},0).wait(2).to({scaleY:0.76,y:216.6},0).wait(2).to({scaleY:0.77,y:216.4},0).wait(2).to({scaleY:0.77,y:216.1},0).wait(2).to({scaleY:0.77,y:215.9},0).wait(2).to({scaleY:0.78,y:215.6},0).wait(16).to({scaleY:0.77,skewX:-0.3,x:327.1,y:216},0).wait(2).to({scaleY:0.77,skewX:-0.8,x:326.6,y:216.3},0).wait(2).to({scaleY:0.76,skewX:-1.4,x:326.1,y:216.6},0).wait(2).to({skewX:-1.3},0).wait(2).to({skewX:-1.4},0).wait(2).to({scaleY:0.77,skewX:-1,x:326.5,y:216.4},0).wait(2).to({scaleY:0.77,skewX:-0.5,x:326.9,y:216.1},0).wait(2).to({scaleY:0.77,skewX:-0.3,x:327.2,y:215.9},0).wait(2).to({scaleY:0.78,skewX:0,x:327.6,y:215.6},0).wait(10).to({_off:true},2).wait(128).to({_off:false,scaleY:0.78,skewX:6.8,x:334.8},0).to({_off:true},2).wait(97));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontleg_5).wait(468).to({_off:false},0).to({_off:true},2).wait(8).to({_off:false,scaleX:0.78,scaleY:0.81,skewX:31.6,skewY:-140.7,x:365.5,y:155.1},0).wait(2).to({scaleX:0.78,scaleY:0.81,skewX:18.8,skewY:-153.5,x:364.3,y:156.1},0).wait(2).to({scaleX:0.78,scaleY:0.81,skewX:6.2,skewY:-166.2,x:363.1,y:157.2},0).to({_off:true},2).wait(12).to({_off:false,skewX:31.6,skewY:-140.7},0).wait(2).to({skewX:6.2,skewY:-166.2},0).to({_off:true},2).wait(6).to({_off:false,scaleX:0.77,scaleY:0.8,skewX:44.6,skewY:-131.4,x:348.6,y:173},0).to({_off:true},2).wait(55));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontleg_6).wait(470).to({_off:false},0).wait(2).to({scaleX:0.78,scaleY:0.81,skewX:67.7,skewY:-104.8},0).to({_off:true},2).wait(14).to({_off:false,scaleX:0.78,scaleY:0.81,skewX:54.8,skewY:-117.6},0).wait(2).to({scaleX:0.78,scaleY:0.81,skewX:67.7,skewY:-104.8},0).to({_off:true},2).wait(12).to({_off:false,scaleX:0.78,scaleY:0.81,skewX:71.5,skewY:-100.9},0).to({_off:true},2).wait(57));

	// Zebra Hind Leg
	this.zebra_hindleg = new lib.ZebraHindLeg();
	this.zebra_hindleg.parent = this;
	this.zebra_hindleg.setTransform(401.9,195.4,0.776,0.776,0,0,180,5.9,-43.1);

	this.zebra_hindleg_1 = new lib.ZebraHindLeg_002();
	this.zebra_hindleg_1.parent = this;
	this.zebra_hindleg_1.setTransform(409.6,193,0.776,0.799,0,5,180,6,-43.4);

	this.zebra_hindleg_2 = new lib.ZebraHindLeg_003();
	this.zebra_hindleg_2.parent = this;
	this.zebra_hindleg_2.setTransform(410.1,193.5,0.776,0.796,0,5.3,180,6,-43.2);

	this.zebra_hindleg_3 = new lib.ZebraHindLeg_004();
	this.zebra_hindleg_3.parent = this;
	this.zebra_hindleg_3.setTransform(410.7,193.7,0.776,0.794,0,5.8,180,5.9,-43.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.zebra_hindleg}]}).to({state:[{t:this.zebra_hindleg}]},40).to({state:[{t:this.zebra_hindleg}]},136).to({state:[{t:this.zebra_hindleg}]},78).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},12).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},14).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},10).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},62).to({state:[{t:this.zebra_hindleg}]},10).to({state:[{t:this.zebra_hindleg}]},18).to({state:[{t:this.zebra_hindleg}]},28).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg_1}]},2).to({state:[{t:this.zebra_hindleg_2}]},2).to({state:[{t:this.zebra_hindleg_3,p:{regX:5.9,regY:-43.2,x:410.7,y:193.7}}]},2).to({state:[{t:this.zebra_hindleg_3,p:{regX:-12.6,regY:66.2,x:416.3,y:280.2}}]},34).to({state:[{t:this.zebra_hindleg_2}]},2).to({state:[{t:this.zebra_hindleg_1}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).to({state:[{t:this.zebra_hindleg}]},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_hindleg).wait(262).to({scaleY:0.78,skewX:-0.3,x:401.5,y:194.8},0).wait(2).to({regX:6,scaleY:0.79,skewX:-0.5,x:401.1,y:194.3},0).wait(2).to({scaleY:0.8,skewX:-0.8,x:400.7,y:193.7},0).wait(14).to({regX:6.2,x:400.3},0).wait(2).to({regX:5.9,skewX:-1,x:400.2},0).wait(2).to({skewX:-1.3,x:400},0).wait(2).to({skewX:-1,x:400.2},0).wait(2).to({regX:6,x:400.3},0).wait(2).to({regX:5.9,skewX:-0.8,x:400.5},0).wait(2).to({regX:6,x:400.7},0).wait(16).to({regX:5.9,skewX:-1,x:400.2},0).wait(2).to({skewX:-1.5,x:399.6},0).wait(2).to({regX:6,skewX:-1.9,x:399},0).wait(2).to({regX:5.9,skewX:-1.8,x:399.1},0).wait(2).to({regX:6,skewX:-1.9,x:399},0).wait(2).to({regX:5.9,skewX:-1.5,x:399.5},0).wait(2).to({regX:6,skewX:-1.3,x:399.9},0).wait(2).to({regX:5.9,skewX:-1,x:400.4},0).wait(2).to({regX:6,skewX:-0.8,x:400.7},0).wait(12).to({scaleY:0.79,skewX:-0.5,x:401.1,y:194.3},0).wait(2).to({regX:5.9,scaleY:0.78,skewX:-0.3,x:401.5,y:194.8},0).wait(2).to({scaleY:0.78,skewX:0,x:401.9,y:195.4},0).wait(120).to({regX:6,scaleY:0.79,skewX:1.3,x:404,y:194.4},0).wait(2).to({regX:5.9,scaleY:0.8,skewX:2.8,x:406.2,y:193.4},0).wait(2).to({regX:6,regY:-43.2,scaleY:0.81,skewX:4.2,x:408.3,y:192.4},0).to({_off:true},2).wait(44).to({_off:false,regX:5.9,regY:-43.1,scaleY:0.8,skewX:2.8,x:406.2,y:193.4},0).wait(4).to({regX:6,scaleY:0.79,skewX:1.3,x:404,y:194.4},0).wait(2).to({regX:5.9,scaleY:0.78,skewX:0,x:401.9,y:195.4},0).wait(47));

	// Zebra Head
	this.zebra_head = new lib.ZebraHead_001();
	this.zebra_head.parent = this;
	this.zebra_head.setTransform(284.4,177.7,0.776,0.776,0,-15,165,-20.4,-7);

	this.zebra_head_1 = new lib.ZebraHead_002_1();
	this.zebra_head_1.parent = this;
	this.zebra_head_1.setTransform(284.4,177.7,0.776,0.776,0,-15,165,-20.4,-7);
	this.zebra_head_1._off = true;

	this.zebra_head_2 = new lib.ZebraHead_003();
	this.zebra_head_2.parent = this;
	this.zebra_head_2.setTransform(284.4,176.6,0.776,0.776,0,-15,165,-20.4,-7);
	this.zebra_head_2._off = true;

	this.zebra_head_3 = new lib.ZebraHead_004();
	this.zebra_head_3.parent = this;
	this.zebra_head_3.setTransform(284.4,176.6,0.776,0.776,0,-15,165,-20.4,-7);
	this.zebra_head_3._off = true;

	this.zebra_head_4 = new lib.ZebraHead_005_1();
	this.zebra_head_4.parent = this;
	this.zebra_head_4.setTransform(284.4,177.7,0.776,0.776,0,-15,165,-20.4,-7);
	this.zebra_head_4._off = true;

	this.zebra_head_5 = new lib.ZebraHead_excited_004_1();
	this.zebra_head_5.parent = this;
	this.zebra_head_5.setTransform(358.2,107.3,0.776,0.776,0,-1,179,-20.2,-7);
	this.zebra_head_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.zebra_head).to({_off:true},2).wait(32).to({_off:false},0).wait(40).to({_off:true},2).wait(76).to({_off:false},0).wait(58).to({_off:true},2).wait(46).to({_off:false,regY:-7.1,scaleX:0.78,scaleY:0.78,skewX:-6.8,skewY:173.2,x:286.1,y:173.8},0).wait(2).to({regY:-7,scaleX:0.78,scaleY:0.78,skewX:-15,skewY:165,x:284.4,y:177.7},0).wait(2).to({regX:-20.5,regY:-7.2,scaleX:0.77,scaleY:0.77,skewX:-21.3,skewY:158.7,x:277.6,y:198.4},0).wait(2).to({regX:-20.6,regY:-7,scaleX:0.78,scaleY:0.78,skewX:-27.9,skewY:152.1,x:277.5,y:219.2},0).wait(2).to({regX:-20.5,regY:-7.1,scaleX:0.78,scaleY:0.78,skewX:-34.5,skewY:145.5,x:286,y:240.5},0).wait(14).to({regY:-7.2,scaleX:0.77,scaleY:0.77,skewX:-37.9,skewY:142.1,x:286.8,y:240.9},0).wait(2).to({skewX:-41.3,skewY:138.7,x:287.4,y:241.5},0).wait(2).to({regX:-20.6,regY:-7,scaleX:0.78,scaleY:0.78,skewX:-44.7,skewY:135.3,x:288.1,y:242.2},0).wait(2).to({scaleX:0.77,scaleY:0.77,skewX:-42.1,skewY:137.9,x:287.6,y:241.7},0).wait(2).to({skewX:-39.6,skewY:140.4,x:287.1,y:241.3},0).wait(2).to({regX:-20.8,regY:-6.7,skewX:-37.1,skewY:142.9,x:286.8,y:241.1},0).wait(2).to({regX:-20.5,regY:-7.1,scaleX:0.78,scaleY:0.78,skewX:-34.5,skewY:145.5,x:286,y:240.5},0).wait(16).to({regX:-20.4,scaleX:0.78,scaleY:0.78,skewX:-31.6,skewY:148.4,x:284.8,y:240.2},0).wait(2).to({regX:-20.5,regY:-7,skewX:-28.6,skewY:151.4,x:283.9,y:239.8},0).wait(2).to({regX:-20.6,scaleX:0.78,scaleY:0.78,skewX:-25.8,skewY:154.2,x:282.9,y:239.4},0).wait(2).to({regY:-7.2,scaleX:0.78,scaleY:0.78,x:282.7,y:239.3},0).wait(2).to({regY:-7,scaleX:0.78,scaleY:0.78,x:282.9,y:239.4},0).wait(2).to({regX:-20.5,scaleX:0.78,scaleY:0.78,skewX:-28,skewY:152,x:283.6,y:239.7},0).wait(2).to({regX:-20.6,skewX:-30.1,skewY:149.9,x:284.5,y:239.9},0).wait(2).to({regX:-21.2,skewX:-32.3,skewY:147.7,x:285.7,y:240},0).wait(2).to({regX:-20.5,regY:-7.1,scaleX:0.78,scaleY:0.78,skewX:-34.5,skewY:145.5,x:286,y:240.5},0).wait(12).to({regX:-20.6,regY:-7,scaleX:0.78,scaleY:0.78,skewX:-27.9,skewY:152.1,x:277.5,y:219.2},0).wait(2).to({regX:-20.5,regY:-7.2,scaleX:0.77,scaleY:0.77,skewX:-21.3,skewY:158.7,x:277.6,y:198.4},0).wait(2).to({regX:-20.4,regY:-7,scaleX:0.78,scaleY:0.78,skewX:-15,skewY:165,x:284.4,y:177.7},0).wait(98).to({_off:true},1).wait(27).to({_off:false,regX:-20.3,regY:-6.8,scaleX:0.78,scaleY:0.78,skewX:-13,skewY:167,x:303.7,y:154.8},0).wait(2).to({regX:-20.4,regY:-7.1,skewX:6,skewY:186,x:325.6,y:129.2},0).to({_off:true},2).wait(36).to({_off:false},0).wait(2).to({regX:-20.3,regY:-6.8,skewX:-13,skewY:167,x:303.7,y:154.8},0).to({_off:true},2).wait(53));
	this.timeline.addTween(cjs.Tween.get(this.zebra_head_1).wait(2).to({_off:false},0).to({_off:true},1).wait(30).to({_off:false},0).to({_off:true},1).wait(42).to({_off:false},0).to({_off:true},1).wait(74).to({_off:false},0).to({_off:true},1).wait(60).to({_off:false},0).to({_off:true},1).wait(43).to({_off:false,scaleX:0.78,scaleY:0.78,skewX:-10.8,skewY:169.2,x:285.3,y:175.8},0).to({_off:true},2).wait(181).to({_off:false,scaleX:0.78,scaleY:0.78,skewX:-15,skewY:165,x:284.4,y:177.7},0).to({_off:true},1).wait(24).to({_off:false,regX:-21.3,regY:-8,skewX:-51.4,skewY:128.6,x:294.1,y:206.9},0).to({_off:true},2).wait(97));
	this.timeline.addTween(cjs.Tween.get(this.zebra_head_2).wait(3).to({_off:false},0).to({_off:true},1).wait(28).to({_off:false},0).to({_off:true},1).wait(44).to({_off:false},0).to({_off:true},1).wait(72).to({_off:false},0).to({_off:true},1).wait(62).to({_off:false},0).to({_off:true},1).wait(40).to({_off:false,y:177.7},0).to({_off:true},2).wait(184).to({_off:false,y:176.6},0).to({_off:true},1).wait(21).to({_off:false,regX:-20.7,scaleX:0.77,scaleY:0.77,skewX:-39.3,skewY:140.7,x:291.1,y:197.7},0).to({_off:true},2).wait(46).to({_off:false},0).wait(2).to({_off:true},2).wait(49));
	this.timeline.addTween(cjs.Tween.get(this.zebra_head_3).wait(4).to({_off:false},0).to({_off:true},1).wait(25).to({_off:false},0).to({_off:true},2).wait(46).to({_off:false},0).to({_off:true},1).wait(69).to({_off:false},0).to({_off:true},2).wait(64).to({_off:false},0).to({_off:true},1).wait(226).to({_off:false},0).to({_off:true},1).wait(18).to({_off:false,regY:-7.2,scaleX:0.78,scaleY:0.78,skewX:-27.1,skewY:152.9,x:287.6,y:187.6},0).to({_off:true},2).wait(52).to({_off:false},0).to({_off:true},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_head_4).wait(5).to({_off:false},0).to({_off:true},25).wait(49).to({_off:false},0).to({_off:true},69).wait(67).to({_off:false},0).to({_off:true},39).wait(188).to({_off:false},0).wait(16).to({_off:true},2).wait(56).to({_off:false},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_head_5).wait(470).to({_off:false},0).wait(2).to({skewX:-1.3,skewY:178.7,x:357.5,y:107.8},0).wait(2).to({regX:-20.1,skewX:-1.8,skewY:178.2,x:356.8,y:108.4},0).wait(2).to({regX:-20.6,skewX:-2.3,skewY:177.7,x:356.1,y:108.8},0).wait(2).to({skewX:-1.8,skewY:178.2,x:356.7,y:108.4},0).wait(2).to({skewX:-1.5,skewY:178.5,x:357.2,y:108.1},0).wait(2).to({regX:-20.7,skewX:-1.3,skewY:178.7,x:357.7,y:107.7},0).wait(2).to({regX:-20.2,skewX:-1,skewY:179,x:358.2,y:107.3},0).wait(2).to({skewX:-1.1,skewY:178.9,x:357.9,y:107.6},0).wait(2).to({skewX:-1.3,skewY:178.7,x:357.5,y:107.8},0).wait(2).to({skewX:-1.5,skewY:178.5,x:357.2,y:108.2},0).wait(2).to({regX:-20.1,skewX:-1.8,skewY:178.2,x:356.8,y:108.4},0).wait(2).to({regX:-20.2,skewX:-2,skewY:178,x:356.5,y:108.6},0).wait(2).to({regX:-20.6,skewX:-2.3,skewY:177.7,x:356.1,y:108.8},0).wait(2).to({skewX:-1.8,skewY:178.2,x:356.7,y:108.4},0).wait(2).to({skewX:-1.5,skewY:178.5,x:357.2,y:108.1},0).wait(2).to({regX:-20.7,skewX:-1.3,skewY:178.7,x:357.7,y:107.7},0).wait(2).to({regX:-20.2,skewX:-1,skewY:179,x:358.2,y:107.3},0).to({_off:true},2).wait(57));

	// Zebra Tail
	this.instance_7 = new lib.ZebraTail_looping();
	this.instance_7.parent = this;
	this.instance_7.setTransform(418.8,188.3,0.776,0.776,0,0,180,1,-9.2);

	this.instance_8 = new lib.ZebraTail();
	this.instance_8.parent = this;
	this.instance_8.setTransform(418.8,188.3,0.776,0.776,0,0,180,1,-9.2);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(176).to({_off:true},78).wait(12).to({_off:false,regY:-9.3,skewX:-27,skewY:153,y:188.2},0).wait(14).to({scaleX:0.78,scaleY:0.78,skewX:-26.8,skewY:153.2,y:187.7},0).wait(2).to({x:418.7,y:187.1},0).wait(2).to({scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153,y:186.5},0).wait(2).to({scaleX:0.78,scaleY:0.78,skewX:-26.8,skewY:153.2,y:187},0).wait(2).to({regX:0.8,regY:-9.2,x:419,y:187.5},0).wait(2).to({regX:1,regY:-9.3,x:418.8,y:187.8},0).wait(2).to({scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153,y:188.2},0).wait(16).to({scaleX:0.78,scaleY:0.78,skewX:-26.8,skewY:153.2,x:418.4,y:187.7},0).wait(2).to({x:417.9,y:187.1},0).wait(2).to({scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153,x:417.4,y:186.5},0).wait(2).to({regY:-9.4,scaleX:0.78,scaleY:0.78,skewX:-26.8,skewY:153.2,x:417.3},0).wait(2).to({regY:-9.3,scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153,x:417.4},0).wait(2).to({regY:-9.4,scaleX:0.78,scaleY:0.78,skewX:-26.8,skewY:153.2,x:417.7,y:186.9},0).wait(2).to({regX:1.1,regY:-9.1,x:418.1,y:187.6},0).wait(2).to({regX:1,x:418.5,y:187.9},0).wait(2).to({regY:-9.3,scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153,x:418.8,y:188.2},0).to({_off:true},10).wait(6).to({_off:false,regX:1.1,skewX:-6,skewY:174},0).wait(90).to({regX:1,regY:-9.2,skewX:0,skewY:180,y:188.3},0).wait(30).to({regX:0.8,scaleX:0.77,scaleY:0.77,skewX:-17.8,skewY:162.2,x:419.7,y:186.1},0).wait(2).to({regX:1.1,skewX:-35.8,skewY:144.2,x:420.4,y:184},0).wait(2).to({regX:0.8,regY:-8.8,scaleX:0.78,scaleY:0.78,skewX:-53.7,skewY:126.3,x:421.5,y:181.9},0).wait(2).to({regY:-8.9,scaleX:0.77,scaleY:0.77,skewX:-40.6,skewY:139.4,x:427.1,y:186.8},0).wait(2).to({regY:-8.8,scaleX:0.78,scaleY:0.78,skewX:-27.6,skewY:152.4,x:433,y:191.9},0).wait(2).to({regX:1,regY:-8.9,scaleX:0.78,scaleY:0.78,skewX:-13.5,skewY:166.5,x:439.2,y:197.2},0).wait(2).to({regY:-9,scaleX:0.78,scaleY:0.78,skewX:-13.8,skewY:166.2,x:439.1,y:197},0).wait(2).to({regY:-8.8,skewX:-14.3,skewY:165.7,x:438.8},0).wait(2).to({regX:0.9,regY:-8.9,scaleX:0.78,scaleY:0.78,skewX:-14.8,skewY:165.2,y:196.9},0).wait(2).to({regX:1,regY:-9.1,scaleX:0.78,scaleY:0.78,skewX:-14.3,skewY:165.7,y:196.8},0).wait(2).to({regY:-9,skewX:-14,skewY:166,x:438.9,y:197},0).wait(2).to({regY:-8.8,skewX:-13.8,skewY:166.2,x:439.1,y:197.1},0).wait(2).to({regY:-8.9,scaleX:0.78,scaleY:0.78,skewX:-13.5,skewY:166.5,x:439.2,y:197.2},0).wait(2).to({regX:1.9,regY:-9.2,scaleX:0.78,scaleY:0.78,skewX:-13.6,skewY:166.4,x:438.4,y:197},0).wait(2).to({regX:1,regY:-9,skewX:-13.8,skewY:166.2,x:439.1},0).wait(2).to({regY:-8.8,skewX:-14,skewY:166,x:439,y:197.1},0).wait(2).to({skewX:-14.3,skewY:165.7,x:438.8,y:197},0).wait(2).to({regX:0.8,regY:-9.2,skewX:-14.5,skewY:165.5,x:438.9,y:196.7},0).wait(2).to({regX:0.9,regY:-8.9,scaleX:0.78,scaleY:0.78,skewX:-14.8,skewY:165.2,x:438.8,y:196.9},0).wait(2).to({regX:1,regY:-9.1,scaleX:0.78,scaleY:0.78,skewX:-14.3,skewY:165.7,y:196.8},0).wait(2).to({regY:-9,skewX:-14,skewY:166,x:438.9,y:197},0).wait(2).to({regY:-8.8,skewX:-13.8,skewY:166.2,x:439.1,y:197.1},0).wait(2).to({regY:-8.9,scaleX:0.78,scaleY:0.78,skewX:-13.5,skewY:166.5,x:439.2,y:197.2},0).wait(2).to({regX:0.8,regY:-8.8,scaleX:0.78,scaleY:0.78,skewX:-27.6,skewY:152.4,x:433,y:191.9},0).wait(2).to({regY:-8.9,scaleX:0.77,scaleY:0.77,skewX:-40.6,skewY:139.4,x:427.1,y:186.8},0).wait(2).to({regX:1.1,regY:-9.2,skewX:-35.8,skewY:144.2,x:420.4,y:184},0).wait(4).to({regX:0.8,skewX:-17.8,skewY:162.2,x:419.7,y:186.1},0).wait(2).to({regX:1,scaleX:0.78,scaleY:0.78,skewX:0,skewY:180,x:418.8,y:188.3},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(254).to({_off:false},0).wait(8).to({regX:1.2,regY:-9.1,scaleX:0.78,scaleY:0.78,skewX:-8.8,skewY:171.2,x:418.7,y:188.4},0).wait(2).to({regX:1.1,regY:-9.2,skewX:-17.8,skewY:162.2,x:418.8,y:188.2},0).to({_off:true},2).wait(68).to({_off:false,regX:1,regY:-9.3,scaleX:0.78,scaleY:0.78,skewX:-27,skewY:153},0).wait(2).to({regX:1.1,regY:-9.2,scaleX:0.78,scaleY:0.78,skewX:-17.8,skewY:162.2},0).wait(2).to({regX:1.2,regY:-9.1,skewX:-8.8,skewY:171.2,x:418.7,y:188.4},0).to({_off:true},2).wait(223));

	// Zebra Neck
	this.zebra_neck = new lib.ZebraNeck();
	this.zebra_neck.parent = this;
	this.zebra_neck.setTransform(316.8,192.7,0.776,0.776,0,0,180,-8.4,13.6);

	this.zebra_neck_1 = new lib.ZebraNeck_excited_004_1();
	this.zebra_neck_1.parent = this;
	this.zebra_neck_1.setTransform(374.4,146.7,0.961,0.562,0,36.7,-137.9,-8.3,13.3);
	this.zebra_neck_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.zebra_neck).wait(256).to({skewX:2,skewY:182,x:317.2,y:191.9},0).wait(2).to({regX:-8.6,skewX:4,skewY:184,x:317.5,y:191},0).wait(2).to({regX:-8.4,skewX:0,skewY:180,x:316.8,y:192.7},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.85,scaleY:0.72,skewX:-21.6,skewY:158.4,x:316.3,y:197.2},0).wait(2).to({regX:-8.4,regY:13.6,scaleX:0.92,scaleY:0.67,skewX:-43.4,skewY:136.6,x:315.9,y:202.2},0).wait(2).to({regX:-8.5,regY:13.5,scaleX:1,scaleY:0.62,skewX:-65.2,skewY:114.8,x:315.5,y:206.8},0).wait(14).to({regX:-8.2,regY:13.7,scaleX:0.99,skewX:-66.7,skewY:113.3,x:315.3,y:207.4},0).wait(2).to({regX:-8.8,skewX:-68.2,skewY:111.8,x:315.4,y:207.3},0).wait(2).to({regX:-8.5,regY:13.3,scaleX:1,skewX:-69.7,skewY:110.3,x:314.9,y:207.7},0).wait(2).to({regX:-8.3,regY:13.1,scaleX:0.99,skewX:-68.7,skewY:111.3,x:314.8,y:207.6},0).wait(2).to({regX:-8.2,regY:13.6,skewX:-67.5,skewY:112.5,x:315.2},0).wait(2).to({regX:-8.4,skewX:-66.4,skewY:113.6,x:315.5,y:207.1},0).wait(2).to({regX:-8.5,regY:13.5,scaleX:1,skewX:-65.2,skewY:114.8,y:206.8},0).wait(16).to({regX:-8.6,regY:13.4,scaleX:0.99,skewX:-63.9,skewY:116.1,x:315.6,y:206.7},0).wait(2).to({regX:-8.5,regY:13.5,skewX:-62.4,skewY:117.6,y:206.8},0).wait(2).to({regX:-8.6,regY:13.4,scaleX:1,skewX:-61,skewY:119,x:315.7,y:206.7},0).wait(2).to({regY:13.3,scaleX:0.99,skewX:-61.2,skewY:118.8},0).wait(2).to({regY:13.4,scaleX:1,skewX:-61,skewY:119},0).wait(2).to({regX:-8.4,regY:13.5,scaleX:0.99,skewX:-62.2,skewY:117.8,x:315.6,y:206.9},0).wait(2).to({regX:-8.5,regY:13.3,skewX:-63.2,skewY:116.8,x:315.5,y:206.8},0).wait(2).to({regY:13.4,skewX:-64.2,skewY:115.8},0).wait(2).to({regY:13.5,scaleX:1,skewX:-65.2,skewY:114.8},0).wait(12).to({regX:-8.4,regY:13.6,scaleX:0.92,scaleY:0.67,skewX:-43.4,skewY:136.6,x:315.9,y:202.2},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.85,scaleY:0.72,skewX:-21.6,skewY:158.4,x:316.3,y:197.2},0).wait(2).to({regX:-8.4,regY:13.6,scaleX:0.78,scaleY:0.78,skewX:0,skewY:180,x:316.8,y:192.7},0).wait(120).to({scaleX:0.76,scaleY:0.8,skewX:-8.8,skewY:170.2,x:319.9,y:198.4},0).wait(2).to({scaleX:0.74,scaleY:0.82,skewX:-17.8,skewY:160.2,x:322.9,y:204},0).wait(2).to({regX:-8.5,scaleX:0.72,scaleY:0.85,skewX:-26.8,skewY:150.3,x:326,y:209.5},0).wait(2).to({regX:-8.4,regY:13.7,scaleX:0.84,scaleY:0.7,skewX:4.3,skewY:185.5,x:337.3,y:172.7},0).wait(2).to({regX:-8.2,regY:13.8,scaleX:0.9,scaleY:0.63,skewX:19.8,skewY:203.1,x:353.3,y:157.1},0).to({_off:true},2).wait(36).to({_off:false},0).wait(2).to({regX:-8.4,regY:13.7,scaleX:0.84,scaleY:0.7,skewX:4.3,skewY:185.5,x:337.3,y:172.7},0).wait(2).to({regY:13.6,scaleX:0.74,scaleY:0.82,skewX:-17.8,skewY:160.2,x:322.9,y:204},0).wait(4).to({scaleX:0.76,scaleY:0.8,skewX:-8.8,skewY:170.2,x:319.9,y:198.4},0).wait(2).to({scaleX:0.78,scaleY:0.78,skewX:0,skewY:180,x:316.8,y:192.7},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_neck_1).wait(470).to({_off:false},0).wait(2).to({regY:13.5,scaleX:0.96,scaleY:0.56,skewX:36.3,skewY:-138.4,x:373.8,y:147.1},0).wait(2).to({regX:-8.2,regY:13.2,skewX:35.8,skewY:-138.7,x:373.2,y:147.4},0).wait(2).to({regY:13.4,scaleX:0.96,scaleY:0.56,skewX:35.5,skewY:-139.1,x:372.7,y:147.9},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.96,skewX:35.8,skewY:-138.9,x:373.3,y:147.6},0).wait(2).to({regX:-8.2,regY:13.5,skewX:36.1,skewY:-138.6,x:373.5,y:147.3},0).wait(2).to({regX:-7.4,regY:14.3,scaleY:0.56,skewX:36.4,skewY:-138.2,x:373.1,y:146.8},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.96,scaleY:0.56,skewX:36.7,skewY:-137.9,x:374.4,y:146.7},0).wait(2).to({regX:-8.2,regY:13.2,scaleX:0.96,scaleY:0.56,skewX:36.4,skewY:-138.1,x:374.1},0).wait(2).to({regX:-8.3,regY:13.5,skewX:36.3,skewY:-138.4,x:373.8,y:147.1},0).wait(2).to({regX:-8.2,regY:13.4,skewX:36.1,skewY:-138.6,x:373.5,y:147.3},0).wait(2).to({regY:13.2,skewX:35.8,skewY:-138.7,x:373.2,y:147.4},0).wait(2).to({scaleY:0.56,skewX:35.6,skewY:-138.9,x:373.1,y:147.6},0).wait(2).to({regY:13.4,scaleX:0.96,skewX:35.5,skewY:-139.1,x:372.7,y:147.9},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.96,skewX:35.8,skewY:-138.9,x:373.3,y:147.6},0).wait(2).to({regX:-8.2,regY:13.5,skewX:36.1,skewY:-138.6,x:373.5,y:147.3},0).wait(2).to({regX:-7.4,regY:14.3,scaleY:0.56,skewX:36.4,skewY:-138.2,x:373.1,y:146.8},0).wait(2).to({regX:-8.3,regY:13.3,scaleX:0.96,scaleY:0.56,skewX:36.7,skewY:-137.9,x:374.4,y:146.7},0).to({_off:true},2).wait(57));

	// Zebra Torso
	this.zebra_torso = new lib.ZebraTorso_001();
	this.zebra_torso.parent = this;
	this.zebra_torso.setTransform(341.7,202.7,0.776,0.776,0,0,180,30.2,-2.1);

	this.zebra_torso_1 = new lib.ZebraTorso_002();
	this.zebra_torso_1.parent = this;
	this.zebra_torso_1.setTransform(341.4,202.8,0.776,0.776,0,0,179.5,30.2,-2.1);

	this.zebra_torso_2 = new lib.ZebraTorso_003();
	this.zebra_torso_2.parent = this;
	this.zebra_torso_2.setTransform(341.1,203,0.776,0.776,0,0,179,30.2,-2.1);

	this.zebra_torso_3 = new lib.ZebraTorso_004();
	this.zebra_torso_3.parent = this;
	this.zebra_torso_3.setTransform(340.8,203.1,0.776,0.776,0,0,178.4,30.2,-2.1);
	this.zebra_torso_3._off = true;

	this.zebra_torso_4 = new lib.ZebraTorso_excited_004_1();
	this.zebra_torso_4.parent = this;
	this.zebra_torso_4.setTransform(381.9,170.1,0.677,0.729,0,41.4,-132.6,30.2,-2.1);
	this.zebra_torso_4._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.zebra_torso}]}).to({state:[{t:this.zebra_torso}]},40).to({state:[{t:this.zebra_torso}]},136).to({state:[{t:this.zebra_torso}]},78).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso_1}]},2).to({state:[{t:this.zebra_torso_2}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},12).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},14).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},2).to({state:[{t:this.zebra_torso_3}]},10).to({state:[{t:this.zebra_torso_2}]},2).to({state:[{t:this.zebra_torso_1}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},62).to({state:[{t:this.zebra_torso}]},10).to({state:[{t:this.zebra_torso}]},18).to({state:[{t:this.zebra_torso}]},28).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso_4}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).to({state:[{t:this.zebra_torso}]},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_torso).wait(256).to({regX:30.4,skewX:0.5,skewY:180.5,x:341.6,y:202.2},0).wait(2).to({regX:30.2,skewX:1.1,skewY:181.1,x:341.8,y:201.6},0).wait(2).to({skewX:0,skewY:180,x:341.7,y:202.7},0).to({_off:true},2).wait(78).to({_off:false},0).wait(120).to({skewX:-3.8,skewY:176.2,x:343.9,y:205.4},0).wait(2).to({regY:-2,scaleX:0.78,scaleY:0.78,skewX:-7.8,skewY:172.2,x:346.1,y:208.1},0).wait(2).to({regY:-2.1,scaleX:0.78,scaleY:0.78,skewX:-12,skewY:168,x:348.2,y:210.7},0).wait(2).to({regX:30.4,regY:-2.5,scaleX:0.73,scaleY:0.75,skewX:14,skewY:197,x:354.4,y:184.9},0).wait(2).to({regX:30.2,regY:-2.1,scaleX:0.7,scaleY:0.74,skewX:27.1,skewY:211.6,x:366.2,y:175},0).to({_off:true},2).wait(36).to({_off:false},0).wait(2).to({regX:30.4,regY:-2.5,scaleX:0.73,scaleY:0.75,skewX:14,skewY:197,x:354.4,y:184.9},0).wait(2).to({regX:30.2,regY:-2,scaleX:0.78,scaleY:0.78,skewX:-7.8,skewY:172.2,x:346.1,y:208.1},0).wait(2).to({skewX:-7.8},0).wait(2).to({regY:-2.1,scaleX:0.78,scaleY:0.78,skewX:-3.8,skewY:176.2,x:343.9,y:205.4},0).wait(2).to({skewX:0,skewY:180,x:341.7,y:202.7},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_torso_3).wait(266).to({_off:false},0).wait(14).to({regY:-2,skewX:-0.1,skewY:178.2,x:340.7,y:203.3},0).wait(2).to({regY:-2.1,skewX:-0.3,skewY:178,x:340.5,y:203.6},0).wait(2).to({skewX:-0.7,skewY:177.7,x:340.4,y:203.8},0).wait(2).to({skewX:-0.5,skewY:178,x:340.5,y:203.6},0).wait(2).to({skewX:-0.3,skewY:178.2,x:340.6,y:203.5},0).wait(2).to({skewX:0,skewY:178.4,x:340.7,y:203.3},0).wait(2).to({x:340.8,y:203.1},0).wait(16).to({regY:-2,skewX:-0.1,skewY:178.2,x:340.3,y:203.3},0).wait(2).to({regY:-2.1,skewX:-0.3,skewY:178,x:339.7,y:203.6},0).wait(2).to({regY:-2,skewX:-0.7,skewY:177.7,x:339.1,y:203.9},0).wait(2).to({regX:30.1,regY:-2.1,skewX:-0.6,x:339.2,y:203.8},0).wait(2).to({regX:30.2,regY:-2,skewX:-0.7,x:339.1,y:203.9},0).wait(2).to({regY:-2.1,skewX:-0.5,skewY:178,x:339.5,y:203.6},0).wait(2).to({skewX:-0.3,skewY:178.2,x:340,y:203.4},0).wait(2).to({skewX:0,skewY:178.4,x:340.4,y:203.3},0).wait(2).to({x:340.8,y:203.1},0).wait(10).to({_off:true},2).wait(227));
	this.timeline.addTween(cjs.Tween.get(this.zebra_torso_4).wait(470).to({_off:false},0).wait(2).to({regX:30.3,regY:-2.2,scaleX:0.68,scaleY:0.73,skewX:40.9,skewY:-133.1,x:381.6,y:170.4},0).wait(2).to({regX:29.2,regY:-4,skewX:40.6,skewY:-133.4,x:382.6,y:170.3},0).wait(2).to({regX:30.2,regY:-2,scaleX:0.68,scaleY:0.73,skewX:40.1,skewY:-133.8,x:380.9,y:171.2},0).wait(2).to({scaleX:0.68,scaleY:0.73,skewX:40.4,skewY:-133.6,x:381.1,y:170.9},0).wait(2).to({regX:29.9,skewX:40.8,skewY:-133.1,x:381.5,y:170.8},0).wait(2).to({regX:30.2,regY:-2.2,skewX:41.1,skewY:-132.9,x:381.7,y:170.3},0).wait(2).to({regY:-2.1,scaleX:0.68,scaleY:0.73,skewX:41.4,skewY:-132.6,x:381.9,y:170.1},0).wait(2).to({regX:30.4,regY:-1.8,scaleX:0.68,scaleY:0.73,skewX:41.1,skewY:-132.9,x:381.5,y:170.4},0).wait(2).to({regX:30.3,regY:-2.2,skewX:40.9,skewY:-133.1,x:381.6},0).wait(2).to({regX:29.9,regY:-2,skewX:40.8,y:170.9},0).wait(2).to({regX:29.2,regY:-4,skewX:40.6,skewY:-133.4,x:382.6,y:170.3},0).wait(2).to({regX:30.7,regY:-2.1,skewX:40.4,skewY:-133.6,x:380.9,y:170.8},0).wait(2).to({regX:30.2,regY:-2,scaleX:0.68,scaleY:0.73,skewX:40.1,skewY:-133.8,y:171.2},0).wait(2).to({scaleX:0.68,scaleY:0.73,skewX:40.4,skewY:-133.6,x:381.1,y:170.9},0).wait(2).to({regX:29.9,skewX:40.8,skewY:-133.1,x:381.5,y:170.8},0).wait(2).to({regX:30.2,regY:-2.2,skewX:41.1,skewY:-132.9,x:381.7,y:170.3},0).wait(2).to({regY:-2.1,scaleX:0.68,scaleY:0.73,skewX:41.4,skewY:-132.6,x:381.9,y:170.1},0).to({_off:true},2).wait(57));

	// Zebra Hind Leg (Back)
	this.zebra_hindlegback = new lib.ZebraHindLegBack();
	this.zebra_hindlegback.parent = this;
	this.zebra_hindlegback.setTransform(401.2,195.2,0.776,0.776,0,0,180,-5.2,-45.8);

	this.zebra_hindlegback_1 = new lib.ZebraHindLegBack_001_1();
	this.zebra_hindlegback_1.parent = this;
	this.zebra_hindlegback_1.setTransform(398,268,0.776,0.802,0,1.8,180,-1,48.4);

	this.zebra_hindlegback_2 = new lib.ZebraHindLeg_excited_004_1();
	this.zebra_hindlegback_2.parent = this;
	this.zebra_hindlegback_2.setTransform(398.2,267.9,0.776,0.903,0,8,180,-1.2,48.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.zebra_hindlegback}]}).to({state:[{t:this.zebra_hindlegback}]},40).to({state:[{t:this.zebra_hindlegback}]},136).to({state:[{t:this.zebra_hindlegback}]},78).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},12).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},14).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},10).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},62).to({state:[{t:this.zebra_hindlegback}]},10).to({state:[{t:this.zebra_hindlegback}]},18).to({state:[{t:this.zebra_hindlegback}]},28).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback_1}]},2).to({state:[{t:this.zebra_hindlegback_2,p:{scaleY:0.903,skewX:8,y:267.9}}]},2).to({state:[{t:this.zebra_hindlegback_2,p:{scaleY:0.894,skewX:6.7,y:267.8}}]},2).to({state:[{t:this.zebra_hindlegback_2,p:{scaleY:0.903,skewX:8,y:267.9}}]},36).to({state:[{t:this.zebra_hindlegback_1}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).to({state:[{t:this.zebra_hindlegback}]},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_hindlegback).wait(262).to({regY:-45.7,scaleY:0.78,skewX:-0.3,x:400.8,y:194.6},0).wait(2).to({regY:-45.8,scaleY:0.79,skewX:-0.5,x:400.4,y:193.9},0).wait(2).to({regY:-45.9,scaleY:0.8,skewX:-0.8,x:400,y:193.4},0).wait(12).to({regX:-1.8,regY:49.1,x:398.4,y:268.8},0).wait(2).to({skewX:-1.3},0).wait(2).to({skewX:-1.8,x:398.3},0).wait(2).to({skewX:-2.3},0).wait(2).to({regX:-1,skewX:-1.8,x:397.7},0).wait(2).to({regX:-1.8,skewX:-1.5,x:398.4},0).wait(2).to({regX:-1.7,skewX:-1,x:398.3},0).wait(2).to({regX:-1.8,skewX:-0.8,x:398.4},0).wait(16).to({skewX:-1.3},0).wait(2).to({skewX:-1.8,x:398.3},0).wait(2).to({skewX:-2.3},0).wait(2).to({x:398.4},0).wait(2).to({x:398.3},0).wait(2).to({regX:-3.9,skewX:-2,x:400},0).wait(2).to({regX:-1.8,skewX:-1.8,x:398.4},0).wait(2).to({skewX:-1.5,x:398.3},0).wait(2).to({skewX:-1.4},0).wait(10).to({regX:-5.2,regY:-45.9,skewX:-0.8,x:400,y:193.4},0).wait(2).to({regY:-45.8,scaleY:0.79,skewX:-0.5,x:400.4,y:193.9},0).wait(2).to({regY:-45.7,scaleY:0.78,skewX:-0.3,x:400.8,y:194.6},0).wait(2).to({regY:-45.8,scaleY:0.78,skewX:0,x:401.2,y:195.2},0).wait(118).to({regX:-1.2,regY:48.4,x:398.1,y:268.3},0).wait(2).to({skewX:0.3,x:398,y:268.2},0).wait(2).to({skewX:0.8,y:268.3},0).wait(2).to({regX:-1,skewX:1.2,x:397.9},0).to({_off:true},2).wait(44).to({_off:false,regX:-1.2,skewX:0.8,x:398},0).wait(4).to({skewX:0.3,y:268.2},0).wait(2).to({skewX:0,x:398.1,y:268.3},0).wait(47));

	// Zebra Front Leg (Back)
	this.zebra_frontlegback = new lib.ZebraFrontLegBack();
	this.zebra_frontlegback.parent = this;
	this.zebra_frontlegback.setTransform(322.8,209.6,0.705,0.705,0,0,180,0,-36.6);

	this.zebra_frontlegback_1 = new lib.ZebraFrontLegBack_excited_0001_1();
	this.zebra_frontlegback_1.parent = this;
	this.zebra_frontlegback_1.setTransform(320.5,267.9,0.705,0.707,0,3,180,3.5,46.1);

	this.zebra_frontlegback_2 = new lib.ZebraFrontLegBack_excited_001b();
	this.zebra_frontlegback_2.parent = this;
	this.zebra_frontlegback_2.setTransform(320.5,267.9,0.705,0.707,0,4.7,180,3.3,46.1);

	this.zebra_frontlegback_3 = new lib.ZebraFrontLegBack_excited_002_1();
	this.zebra_frontlegback_3.parent = this;
	this.zebra_frontlegback_3.setTransform(312.1,237,0.704,0.708,0,22.3,-156.4,3.3,46.1);

	this.zebra_frontlegback_4 = new lib.ZebraFrontLegBack_excited_003_1();
	this.zebra_frontlegback_4.parent = this;
	this.zebra_frontlegback_4.setTransform(350.5,165.3,0.703,0.709,0,52.3,-123.4,-4.8,-24.3);

	this.zebra_frontlegback_5 = new lib.ZebraFrontLegBack_excited_001_1();
	this.zebra_frontlegback_5.parent = this;
	this.zebra_frontlegback_5.setTransform(369.9,163.9,0.705,0.711,0,74.7,-97.9,-13,-37.8);

	this.zebra_frontlegback_6 = new lib.ZebraFrontLegBack_excited_005_1();
	this.zebra_frontlegback_6.parent = this;
	this.zebra_frontlegback_6.setTransform(368.1,162.3,0.705,0.711,0,105.4,-67.2,-13.5,-37.5);

	this.zebra_frontlegback_7 = new lib.ZebraFrontLegBack_excited_006_1();
	this.zebra_frontlegback_7.parent = this;
	this.zebra_frontlegback_7.setTransform(369.1,158.9,0.705,0.711,0,79.5,-93.1,-13.8,-38.5);
	this.zebra_frontlegback_7._off = true;

	this.zebra_frontlegback_8 = new lib.ZebraFrontLegBack_excited_007_1();
	this.zebra_frontlegback_8.parent = this;
	this.zebra_frontlegback_8.setTransform(370.6,146.1,0.705,0.711,0,3.3,-169.3,-13.2,-37.9);
	this.zebra_frontlegback_8._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.zebra_frontlegback}]}).to({state:[{t:this.zebra_frontlegback}]},40).to({state:[{t:this.zebra_frontlegback}]},136).to({state:[{t:this.zebra_frontlegback}]},78).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},12).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},14).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},10).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},62).to({state:[{t:this.zebra_frontlegback}]},10).to({state:[{t:this.zebra_frontlegback}]},18).to({state:[{t:this.zebra_frontlegback}]},28).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback_1}]},2).to({state:[{t:this.zebra_frontlegback_2}]},2).to({state:[{t:this.zebra_frontlegback_3}]},2).to({state:[{t:this.zebra_frontlegback_4}]},2).to({state:[{t:this.zebra_frontlegback_5,p:{regX:-13,skewX:74.7,skewY:-97.9,x:369.9,y:163.9}}]},2).to({state:[{t:this.zebra_frontlegback_5,p:{regX:-13.1,skewX:90,skewY:-82.7,x:369,y:163.1}}]},2).to({state:[{t:this.zebra_frontlegback_6,p:{regX:-13.5,skewX:105.4,skewY:-67.2,x:368.1,y:162.3,regY:-37.5}}]},2).to({state:[{t:this.zebra_frontlegback_6,p:{regX:-13.7,skewX:92.3,skewY:-80.2,x:368.6,y:160.7,regY:-37.5}}]},2).to({state:[{t:this.zebra_frontlegback_7}]},2).to({state:[{t:this.zebra_frontlegback_7}]},2).to({state:[{t:this.zebra_frontlegback_7}]},2).to({state:[{t:this.zebra_frontlegback_8}]},2).to({state:[{t:this.zebra_frontlegback_8}]},2).to({state:[{t:this.zebra_frontlegback_5,p:{regX:-13,skewX:74.7,skewY:-97.9,x:369.9,y:163.9}}]},2).to({state:[{t:this.zebra_frontlegback_5,p:{regX:-13.1,skewX:90,skewY:-82.7,x:367.8,y:163.1}}]},2).to({state:[{t:this.zebra_frontlegback_6,p:{regX:-13.5,skewX:105.4,skewY:-67.2,x:365.7,y:162.3,regY:-37.6}}]},2).to({state:[{t:this.zebra_frontlegback_6,p:{regX:-13.4,skewX:92.3,skewY:-80.2,x:368.8,y:160.6,regY:-39.6}}]},2).to({state:[{t:this.zebra_frontlegback_7}]},2).to({state:[{t:this.zebra_frontlegback_7}]},2).to({state:[{t:this.zebra_frontlegback_8}]},2).to({state:[{t:this.zebra_frontlegback_8}]},2).to({state:[{t:this.zebra_frontlegback_8}]},2).to({state:[{t:this.zebra_frontlegback_4}]},2).to({state:[{t:this.zebra_frontlegback_3}]},2).to({state:[{t:this.zebra_frontlegback_1}]},2).to({state:[{t:this.zebra_frontlegback_1}]},2).to({state:[{t:this.zebra_frontlegback}]},2).to({state:[{t:this.zebra_frontlegback}]},2).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontlegback).wait(280).to({scaleY:0.7,y:209.9},0).wait(2).to({scaleY:0.7,y:210.4},0).wait(2).to({regY:-36.8,scaleY:0.69,y:210.6},0).wait(2).to({regY:-36.7,scaleY:0.7,y:210.4},0).wait(2).to({regY:-36.8,scaleY:0.7,y:210.1},0).wait(2).to({scaleY:0.7,y:209.8},0).wait(2).to({regY:-36.6,scaleY:0.71,y:209.6},0).wait(16).to({regX:-0.1,scaleY:0.7,skewX:-0.3,x:322.3,y:210},0).wait(2).to({regX:0,scaleY:0.7,skewX:-0.8,x:321.8,y:210.4},0).wait(2).to({regY:-36.8,scaleY:0.69,skewX:-1.4,x:321.2,y:210.6},0).wait(2).to({regX:0.1,skewX:-1.3},0).wait(2).to({regX:0,skewX:-1.4},0).wait(2).to({regX:0.1,regY:-36.7,scaleY:0.7,skewX:-1,x:321.6,y:210.4},0).wait(2).to({regX:2.3,regY:-36.8,scaleY:0.7,skewX:-0.5,x:320.4,y:210},0).wait(2).to({regX:-0.1,scaleY:0.7,skewX:-0.3,x:322.5,y:209.8},0).wait(2).to({regX:0,regY:-36.6,scaleY:0.71,skewX:0,x:322.8,y:209.6},0).wait(88).to({regX:3.6,regY:46.1,x:320.3,y:267.9},0).wait(48).to({scaleY:0.71,skewX:1.5},0).to({_off:true},2).wait(52).to({_off:false},0).wait(2).to({scaleY:0.71,skewX:0},0).wait(47));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontlegback_7).wait(478).to({_off:false},0).wait(2).to({regY:-38.4,scaleX:0.7,scaleY:0.71,skewX:63.2,skewY:-109.5,x:373,y:157.6},0).wait(2).to({regY:-37.9,scaleX:0.71,scaleY:0.71,skewX:46.5,skewY:-126.1,x:377,y:156.3},0).to({_off:true},2).wait(12).to({_off:false,regY:-38.5,skewX:79.5,skewY:-93.1,x:369.1,y:158.9},0).wait(2).to({regY:-37.9,skewX:46.5,skewY:-126.1,x:377,y:156.3},0).to({_off:true},2).wait(63));
	this.timeline.addTween(cjs.Tween.get(this.zebra_frontlegback_8).wait(484).to({_off:false},0).wait(2).to({regX:-13.8,regY:-37.8,skewX:43.3,skewY:-129.3,x:372.1,y:159.2},0).to({_off:true},2).wait(12).to({_off:false,regX:-13.2,regY:-37.9,skewX:3.3,skewY:-169.3,x:370.6,y:146.1},0).wait(2).to({regX:-13.8,regY:-37.8,skewX:43.3,skewY:-129.3,x:372.1,y:159.2},0).wait(2).to({regX:-13.7,scaleX:0.7,scaleY:0.71,skewX:47.9,skewY:-126.3,x:361.3,y:162.2},0).to({_off:true},2).wait(57));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(238.6,152.1,216.7,134.1);


(lib.zebra = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// tummyGlow
	this.tummyGlow = new lib.zebra_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(219.5,187.8,0.978,0.978,0,0,0,36.6,16.5);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(2, 2, 1)];
	this.tummyGlow.cache(-4,-4,82,41);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// backGlow
	this.backGlow = new lib.zebra_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(218,153.9,0.978,1.017,1.7,0,0,51.3,21.7);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(2, 2, 1)];
	this.backGlow.cache(-3,-7,105,49);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.zebra_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(278.6,200.8,1,1,0,0,0,32.2,69.8);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(2, 2, 1)];
	this.legGlow.cache(-94,32,162,111);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// maneGlow
	this.maneGlow = new lib.zebra_maneGlow();
	this.maneGlow.parent = this;
	this.maneGlow.setTransform(140.5,118.6,1,1,0,0,0,32.8,13.4);
	this.maneGlow.alpha = 0;
	this.maneGlow.filters = [new cjs.BlurFilter(2, 2, 1)];
	this.maneGlow.cache(-14,-1,80,27);

	this.timeline.addTween(cjs.Tween.get(this.maneGlow).wait(1));

	// Layer 2
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(301.3,165.3,1.4,0.402,-91.7);

	this.leg = new lib.invisiblebox();
	this.leg.parent = this;
	this.leg.setTransform(303,239.1,1.4,0.402,-91.7);

	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(108.7,114.9,0.311,0.496,9.2);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(170.8,220,2.234,0.687,-95.8);

	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(276.5,199.1,3.068,0.785,-91.7);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(221.1,193.2,1.799,0.63,-2.6);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(213.6,149.1,2.09,0.911,0.7);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(139.4,155.1,1.059,0.903,0,30.9,24);

	this.mane = new lib.invisiblebox();
	this.mane.parent = this;
	this.mane.setTransform(143.4,119.4,1.358,0.496,9.2);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(90.3,162.7,0.698,0.914,-22.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.mouth},{t:this.mane},{t:this.neck},{t:this.back},{t:this.tummy},{t:this.leg2},{t:this.leg1},{t:this.ear},{t:this.leg},{t:this.tail}]}).wait(1));

	// Layer 1
	this.tummySparkle = new lib.hintsparkle();
	this.tummySparkle.parent = this;
	this.tummySparkle.setTransform(219.3,194.3,1.781,1.781);

	this.legSparkle = new lib.hintsparkle();
	this.legSparkle.parent = this;
	this.legSparkle.setTransform(288,201.9,1.781,1.781);

	this.backSparkle = new lib.hintsparkle();
	this.backSparkle.parent = this;
	this.backSparkle.setTransform(213.4,144.4,1.781,1.781);

	this.maneSparkle = new lib.hintsparkle();
	this.maneSparkle.parent = this;
	this.maneSparkle.setTransform(143.3,119.5,1.781,1.781);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.maneSparkle},{t:this.backSparkle},{t:this.legSparkle},{t:this.tummySparkle}]}).wait(1));

	// main
	this.main = new lib.Zebra();
	this.main.parent = this;
	this.main.setTransform(187.2,177.6,1.324,1.324,0,0,0,337.9,211.2);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.zebra, new cjs.Rectangle(55.6,99.3,287,177.8), null);


// stage content:
(lib.MWzebra = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWzebra_atlas_.png?1528312531392", id:"MWzebra_atlas_"}
	],
	preloads: []
};




})(lib_Zebra = lib_Zebra||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Zebra, images, createjs, ss, AdobeAn;